import { extendGettingStartedTranslations } from "../../content/gettingStarted";
const messages = {
  en: {
    translations: {
      gettingStarted: {
        hello: "Welcome, {{name}}",
        title: "Getting started",
        subtitle: "Complete the basics to start attending.",
        next: "Next:",
        completed: "{{done}} / {{total}} completed",
        allDone: "All set: initial setup is complete.",
        steps: {
          connection: {
            title: "Create your first connection",
            desc: "Connect a channel to start receiving chats.",
            time: "2 min",
          },
          greeting: {
            title: "Customize the greeting message",
            desc: "Set the first message your customers receive.",
            time: "1 min",
          },
          queue: {
            title: "Create a department",
            desc: "Create departments to organize your inbox.",
            time: "1 min",
          },
          invite: {
            title: "Invite people",
            desc: "Invite users and admins to your company.",
            time: "1 min",
          },
          assignment: {
            title: "Set automatic assignment",
            desc: "Link departments to your WhatsApp connection.",
            time: "30s",
          },
        },
        extrasTitle: "Unlock more of your operation",
        extrasSubtitle: "Other tools to help your team attend better.",
        extras: {
          new: "New",
          quick: {
            title: "Quick replies",
            desc: "Ready-made messages, triggered with \"/\" in chat.",
          },
          tags: {
            title: "Tags",
            desc: "Organize contacts and reasons for contact.",
          },
          kanban: {
            title: "Kanban",
            desc: "See your attention funnel in columns.",
          },
          ai: {
            title: "AI agents",
            desc: "Turn your knowledge base into automatic support.",
          },
          campaigns: {
            title: "Campaigns",
            desc: "Send bulk messages to contact lists.",
          },
          schedules: {
            title: "Scheduled messages",
            desc: "Schedule one-to-one messages for later.",
          },
          chat: {
            title: "Internal chat",
            desc: "Coordinate the team without leaving Watoolx.",
          },
          agenda: {
            title: "Calendar",
            desc: "Appointments, reminders and follow-up.",
          },
          roles: {
            title: "Team and user types",
            desc: "Invite agents and supervisors. Admin configures the business; each agent handles their own queues.",
          },
          csat: {
            title: "CSAT",
            desc: "Measure satisfaction after each conversation.",
          },
        },
      },
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      companies: {
        title: "Company registration",
        form: {
          name: "Company name",
          email: "Email",
          phone: "WhatsApp number",
          plan: "Plans",
          status: "Status",
          campaigns: "Campaigns",
          dueDate: "Due date",
          recurrence: "Recurrence",
          token: "Token",
          submit: "Register",
          success: "Company created successfully!",
        },
        table: {
          name: "Name",
          email: "Email",
          phone: "Phone",
          plan: "Plans",
          campaigns: "Campaigns",
          status: "Status",
          createdAt: "Created on",
          dueDate: "Due date",
        },
        messages: {
          loadError: "Could not load the records list",
          saveSuccess: "Operation completed successfully!",
          saveError:
            "Could not complete the operation. Check for duplicate company name or incomplete fields.",
          deleteSuccess: "Operation completed successfully!",
          deleteError: "Could not complete the operation",
          deleteTitle: "Delete record",
          deleteMessage: "Do you really want to delete this record?",
          registerRefreshPage: "Company registered. Refresh the page to see changes.",
        },
        formTitle: {
          edit: "Edit company",
          registerNew: "Register new company",
        },
        sections: {
          basicInfo: "Basic information",
          configuration: "Settings",
        },
        loadingPlans: "Loading plans...",
        timezone: {
          label: "Time zone",
          loading: "Loading time zones...",
          loadingValue: "{{tz}} (loading...)",
          fallbackCurrent: "{{tz}} (current)",
          hint: "Time zone for displaying dates and times in messages and tickets.",
          ariaLabel: "Time zone",
        },
        grid: {
          emptyTitle: "No companies registered",
          emptySubtitle: "Start by registering your first company",
        },
        tooltips: {
          editCompany: "Edit company",
        },
        buttons: {
          clear: "Clear",
          delete: "Delete",
          save: "Save",
          addDueDate: "+ Due date",
          user: "User",
          registerCompany: "Register company",
          saving: "Saving...",
        },
        register: {
          formTitle: "Register new company",
          companyInfoSection: "Company information",
          successTitle: "Company registered successfully!",
          loadPlansError: "Could not load available plans",
          closingForm_one: "Closing the form in {{count}} second...",
          closingForm_other: "Closing the form in {{count}} seconds...",
          redirecting_one: "Redirecting to the Companies tab in {{count}} second...",
          redirecting_other: "Redirecting to the Companies tab in {{count}} seconds...",
          validation: {
            nameMin: "Name too short",
            nameMax: "Name too long",
            nameRequired: "Name is required",
            passwordMin: "Password too short",
            passwordMax: "Password too long",
            passwordRequired: "Password is required",
            emailInvalid: "Invalid email",
            emailRequired: "Email is required",
            phoneMin: "Phone number too short",
            phoneRequired: "WhatsApp number is required",
            planRequired: "Plan is required",
          },
          buttons: {
            cancel: "Cancel",
            back: "Back",
            registering: "Registering...",
            registered: "Registered!",
          },
        },
        values: {
          yes: "Yes",
          no: "No",
          enabled: "Enabled",
          disabled: "Disabled",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semiannual: "Semiannual",
          annual: "Annual",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          token: "Token",
          tokenEmpty: "No token (edit the connection to set one)",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
          deletedAll: "All contacts deleted successfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitle: "Import contacts",
          deleteAllTitle: "Delete all",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          deleteAllMessage:
            "Are you sure you want to delete all contacts? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
          importAgendaMessage: "There are {count} contacts in your address book. Import them?",
          exportTitle: "Export contacts",
          exportMessage: "Are you sure you want to export the selected contacts?",
          exportAllMessage: "Are you sure you want to export all contacts?",
          titleExportAll: "Export all contacts",
          titleExportOne: "Export 1 contact",
          titleExportMany: "Export {{count}} contacts",
          titleDeleteOne: "Delete 1 contact",
          titleDeleteMany: "Delete {{count}} contacts",
          exportConfirmAll: "Are you sure you want to export all contacts?",
          exportConfirmMany: "Are you sure you want to export {{count}} contact(s)?",
          deleteSelectedMany:
            "Are you sure you want to delete {{count}} contact(s)? All related tickets will be lost.",
        },
        tooltips: {
          importAgendaDisabled:
            "This feature is temporarily disabled. Baileys 6.7.21 does not support fetching contacts directly. It will be re-enabled when a compatible Baileys version is available.",
        },
        buttons: {
          import: "Import address book",
          importSheet: "Import spreadsheet",
          add: "Add",
          export: "Export",
          delete: "Delete",
          downloadTemplate: "Download template",
        },
        table: {
          profile: "Profile",
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          lastInteraction: "Last interaction",
          status: "Status",
          actions: "Actions",
        },
        messages: {
          selectToExport: "Select at least one contact to export",
          processingExport: "Processing {count} contacts... This may take a few seconds.",
          exportSuccess: "Contacts exported successfully",
          exportError: "Could not export contacts. Please try again.",
          checkingAgenda: "Checking phone address book...",
          agendaEmpty: "No contacts were found in the phone address book.",
          agendaUnavailable:
            "Could not read the address book. Check that the WhatsApp connection is online.",
          importInvalidResponse: "Invalid server response",
          importErrorGeneric: "Could not import contacts",
          templateDownloadSuccess: "Template downloaded successfully",
          templateDownloadError: "Could not download the template",
        },
        pagination: {
          rowsPerPage: "Rows per page:",
          displayedRows: "{{from}}–{{to}} of {{count}}",
        },
        badge: {
          contact: "contact",
          contacts: "contacts",
        },
      },
      promptModal: {
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Max tokens in the response",
          temperature: "Temperature",
          apikey: "API key",
          max_messages: "Max messages in history",
          voiceKey: "Voice API key",
          voiceRegion: "Voice region",
        },
        success: "Prompt saved successfully!",
        title: {
          add: "Add prompt",
          edit: "Edit prompt",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          cancelUpper: "CANCEL",
          expand: "EXPAND",
          saveChanges: "Save changes",
        },
        sections: {
          provider: "AI provider setup",
          api: "API configuration",
          basic: "Basic information",
          advanced: "Advanced settings",
          media: "Media files",
          workMode: "Work mode",
        },
        providerInfo: {
          title: "AI provider setup",
          body1:
            "Choose the AI provider this prompt will use. Each provider offers different models and capabilities for your needs.",
          body2:
            "Available providers: official OpenAI, Google Gemini (AI Studio), Anthropic Claude, DeepSeek, Kimi, and OpenRouter. Each option needs that provider’s API key (OpenRouter uses sk-or-v1-…).",
        },
        mustValidateBeforeSave:
          "You must validate the API key and provider before saving. Use the “Test connection” button.",
        mustValidateBeforeSaveWithStored:
          "If you changed provider or pasted a new key, run “Test connection”. To edit only prompt text/options, leave the key empty and keep the same provider.",
        validation: {
          nameRequired: "Name is required",
          apiKeyRequired: "API key is required",
          promptRequired: "Prompt is required",
          maxTokensRequired: "Max tokens is required",
          temperatureRequired: "Temperature is required",
          maxMessagesRequired: "Max messages is required",
        },
        fields: {
          aiProvider: "AI provider",
          promptName: "Prompt name",
          promptNameHelper: "E.g. Support bot, sales assistant…",
          promptNamePlaceholder: "E.g. Support bot",
          mainPrompt: "Main prompt",
          mainPromptHelper: "Define how the AI should behave. Be specific and clear.",
          mainPromptPlaceholder:
            "You are a technical support assistant. Reply in a professional, helpful way…",
          charCount: "Character count: {{count}}",
          temperature: "Temperature",
          temperatureHelper: "0.0 = deterministic, 2.0 = very creative",
          maxTokens: "Max tokens",
          maxTokensHelper: "Token limit for the response",
          maxMessages: "Max messages",
          maxMessagesHelper: "Messages kept in context",
          queueOptional: "Departments (optional)",
          noQueue: "No department",
          workModeLabel: "Work mode",
          workModeLayers: "Context layers",
          workModePdfs: "PDF documents",
          workModeHintLayers: "Uses context layers triggered by keywords",
          workModeHintPdfs: "Upload PDFs for the AI to learn from",
        },
        apiTest: {
          validating: "Validating…",
          validated: "✅ Validated",
          validatedHelper: "✅ API key validated",
          storedKeyMaskPlaceholder:
            "Paste here only when changing the key (when editing, the saved key is shown).",
          storedKeyHelper:
            "When editing this prompt your API key is loaded from the server. Leave as-is to keep it or replace it to update. Use Test connection to validate.",
          testConnection: "Test connection",
          enterApiKeyFirst: "Please enter an API key first",
          selectProviderFirst: "Please select a provider first",
          keyTooShortToast: "The API key looks too short. Check that it is correct.",
          keyTooShort: "API key too short",
          connectionSuccess: "Connection successful",
          validationFailed: "Validation failed",
          validateError: "Error validating API",
          unknownError: "Unknown error",
        },
        media: {
          savePromptFirst: "Save the prompt first",
          savePromptFirstToast: "Save the prompt first",
          unknownFileType: "Error: unrecognized file type",
          noFilesSelected: "No files selected",
          unexpectedError: "Unexpected error: {{message}}",
          fileDeleted: "File deleted successfully",
          deleteFileError: "Error deleting file: {{message}}",
          maxSixFiles: "Maximum 6 files per prompt",
          urlAdded: "External URL added successfully",
          urlAddError: "Error adding URL: {{message}}",
          addUrl: "Add URL",
          uploadFile: "Upload file",
          hintFiles: "📎 You can add up to 6 media files (images, video, audio, documents)",
          hintLimits: "📏 Limits: images/audio 10 MB, video/documents 15 MB",
          hintSyntax: "💡 Use [MEDIA: filename.ext] in your prompt to reference files",
          filesCount: "{{current}}/6 files added",
          uploadSuccessCount: "{{count}} file(s) added successfully",
          maxSixWithCounts:
            "Maximum 6 files per prompt. You already have {{current}} and are adding {{adding}}. You can only add {{remaining}} more.",
          maxSixNoMore:
            "Maximum 6 files per prompt. You already have {{count}} files. No more can be added.",
          someRejected: "Some files could not be added: {{list}}",
          fileTooBig: "{{name}}: exceeds {{maxMb}} MB",
          uploadPartial: "{{uploaded}} file(s) added, {{failed}} failed: {{names}}",
          uploadFailedDetail: "Error uploading files: {{details}}",
          uploadNone: "Could not upload any file. Check the console for details.",
        },
        urlDialog: {
          title: "Add external URL",
          urlLabel: "File URL",
          urlPlaceholder: "https://example.com/file.jpg",
          captionLabel: "Description (optional)",
          captionPlaceholder: "File description",
          hintPublic: "💡 Make sure the URL is publicly accessible",
          add: "Add",
          close: "Close",
        },
        expanded: {
          confirmClose: "Save changes before closing?",
          title: "Expanded editor — main prompt",
          unsavedChip: "Unsaved changes",
          intro:
            "Edit your prompt with more space. Media references [MEDIA: filename.ext] will be highlighted in the preview.",
          editorPlaceholder: "Write your prompt here…",
          charCount: "Character count: {{count}}",
          previewTitle: "Preview (highlighted):",
          toastSaved: "Prompt updated successfully",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Name",
          queue: "Sector/Queue",
          max_tokens: "Max response tokens",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteTitleNamed: "Delete prompt «{{name}}»?",
          deleteMessage: "Are you sure? This cannot be undone!",
        },
        buttons: {
          add: "Add prompt",
        },
        listPage: {
          title: "AI prompts",
          addButton: "Add prompt",
          providersTitle: "Available AI providers",
          providersIntro:
            "Choose the AI provider that best fits your needs. We support official providers: OpenAI, Gemini, Grok, Deepseek®, and OpenRouter.",
          providersApiKey:
            "Each provider offers different models and capabilities. Make sure you have a valid API key for the selected provider.",
          tablePromptName: "Prompt name",
          tableProvider: "AI provider",
          tableMaxTokens: "Max tokens",
          tableTemperature: "Temperature",
          tableMaxMessages: "Max messages",
          tableActions: "Actions",
          tokensChip: "{{count}} tokens",
          tooltipEdit: "Edit prompt",
          tooltipDelete: "Delete prompt",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add department",
          edit: "Edit department",
        },
        tabs: {
          queueData: "Department data",
          serviceHours: "Service hours",
        },
        automation: {
          title: "Process automation",
          intro:
            "You can automate conversations with custom prompts, FlowBuilder workflows, external integrations, or a menu chatbot: the contact taps buttons in the chat instead of free text. Only one of the four can be active at a time; all are optional.",
        },
        form: {
          name: "Name",
          departmentName: "Department name",
          color: "Color",
          greetingMessage: "Greeting message",
          enableGreeting: "Enable greeting",
          greetingEnabledOn: "Enabled — the welcome message will be sent.",
          greetingEnabledOff: "Disabled — no greeting is shown or sent.",
          greetingRequired: "If greeting is enabled, you must enter a message.",
          outOfHoursMessage: "Out of hours message",
          integrationId: "Integration",
          noIntegration: "No integration",
        },
        confirmationModal: {
          deleteTitle: "Delete",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        schedules: {
          title: "Scheduled messages",
          confirmationModal: {
            deleteTitle: "Delete this schedule?",
            deleteMessage: "This cannot be undone.",
          },
          table: {
            contact: "Contact",
            body: "Message",
            sendAt: "Scheduled date",
            sentAt: "Sent at",
            status: "Status",
            actions: "Actions",
          },
          buttons: {
            add: "New schedule",
          },
          toasts: {
            deleted: "Schedule deleted successfully.",
          },
          saveSuccess: "Business hours saved.",
          saveButton: "Save hours",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "User type",
          whatsapp: "Default connection",
          whatsappHint:
            "Used in the inbox and in Negocio (deliveries, reminders and alerts). WhatsApp or Telegram depending on the connection.",
          language: "Panel language",
          profileHint:
            "Admin configures the business. Supervisor sees all tickets in their queues. Agent handles only their own.",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      scheduleModal: {
        title: { add: "New schedule", edit: "Edit schedule" },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Scheduled date & time",
          sentAt: "Sent at",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          cancelMeeting: "Cancel meeting",
          exit: "Exit",
        },
        selectConnectionPlaceholder: "Select a connection",
        bodyCharCounter: "{{current}}/500 characters",
        success: "Schedule saved successfully.",
        toasts: {
          deleted: "Attachment removed successfully.",
          meetingCancelled: "Meeting cancelled successfully.",
          updated: "✅ Schedule updated successfully",
          created: "✅ Schedule created successfully",
          noDataSave: "❌ Error: nothing to save",
        },
        confirmationModal: {
          deleteTitle: "Remove attachment",
          deleteMessage: "Remove this attachment?",
        },
        cancelMeetingTitle: "Cancel meeting",
        cancelMeetingMessage:
          "Are you sure you want to cancel this meeting? A cancellation message will be sent to the contact.",
        confirmScheduleTitle: "Confirm scheduled message?",
        confirmScheduleDate: "Date & time:",
        confirmScheduleContact: "Contact:",
        confirmScheduleWhatsapp: "Connection:",
        confirmScheduleMessage: "Message:",
        confirmScheduleQuestion: "Do you confirm scheduling with the details shown?",
        validationErrorTitle: "❌ Validation error",
        understood: "OK",
        validationGeneric: "Could not validate the schedule",
        contactNotFound: "Contact not found",
        whatsappNotFound: "Connection not found",
        dialogStatusErro: "Send error",
        dialogStatusPrefix: "Message",
        autocompleteNoContacts: "No contacts found",
        searchContactLabel: "Type to search contacts",
        searchContactPlaceholder: "Click to see available contacts",
        attachFile: "Attach file",
        validation: {
          required: "Required",
          invalidDateTime: "❌ Invalid date/time",
          pastDateTime: "❌ Cannot schedule in the past. Current time: {{now}}",
          minTenMinutes: "❌ Minimum lead time is 10 minutes. Earliest allowed: {{min}}",
          maxOneYear: "❌ Cannot schedule more than one year ahead",
          febMaxDays: "❌ February cannot have more than 29 days",
          feb29Leap: "❌ Feb 29 only exists in leap years",
          month30: "❌ Month {{month}} cannot have more than 30 days",
          bodyShort: "Message too short",
          messageMax: "❌ Message cannot exceed 500 characters",
          messageMinChars: "❌ Message must be at least 3 characters",
          messageMinValid: "❌ Message needs at least 2 valid characters",
          allFieldsRequired:
            "❌ All fields are required: contact, connection, message and date/time",
        },
        connectionFallback: "Connection {{id}}",
      },
      tagModal: {
        title: { add: "New tag", edit: "Edit tag" },
        form: {
          name: "Name",
          color: "Color",
          namePlaceholder: "E.g. Support, Lead, Follow-up…",
          pickColorTitle: "Pick color",
          kanbanLabel: "Use in Kanban",
          kanbanHint: "Tags with Kanban enabled appear as columns on the board",
        },
        validation: { nameMin: "Name too short", required: "Required" },
        buttons: { okAdd: "Add", okEdit: "Save", cancel: "Cancel" },
        success: "Tag saved successfully.",
      },
      schedulePage: {
        moduleTitle: "Agenda module",
        scheduledTotal: "{{count}} schedules",
        title: "Schedules ({{count}})",
        notAvailable: "N/A",
        viewTable: "Table view",
        viewCalendar: "Calendar view",
        newButton: "New schedule",
        table: {
          date: "Date",
          time: "Time",
          contact: "Contact",
          connection: "Connection",
          message: "Message",
          status: "Status",
          actions: "Actions",
        },
        status: {
          error: "Error",
          cancelled: "Cancelled",
          sent: "Sent",
          overdue: "Overdue",
          pending: "Pending",
        },
        cancelMeetingTitle: "Cancel meeting?",
        cancelScheduleTitle: "Cancel schedule?",
        cancelMeetingMessage: "Cancel this meeting? All related reminders will be removed.",
        cancelScheduleMessage:
          "Cancel this schedule? A cancellation message will be sent to the contact.",
        toastMeetingCancelled: "Meeting cancelled",
        toastScheduleCancelled: "Schedule cancelled",
        deleteTitleAlreadyCancelled: "Already cancelled",
        deleteTitleCancel: "Cancel schedule",
        calendar: {
          date: "Date",
          time: "Time",
          event: "Event",
          allDay: "All day",
          week: "Week",
          work_week: "Schedules",
          day: "Day",
          month: "Month",
          previous: "Previous",
          next: "Next",
          yesterday: "Yesterday",
          tomorrow: "Tomorrow",
          today: "Today",
          agenda: "Agenda",
          noEventsInRange: "No schedules in this range.",
          showMore: "+{{total}} more",
        },
      },
      appointmentsModule: {
        page: {
          moduleTitle: "Agenda module",
          pendingLine: "• {{count}} pending requests",
          newAppointment: "New appointment",
          tabs: {
            dashboard: "Dashboard",
            calendar: "Calendar",
            pending: "Pending",
            history: "History",
            settings: "Settings",
          },
          accessDeniedTitle: "You don’t have access to the Agenda module",
          accessDeniedP1:
            "You must be linked as a professional/instructor in Agenda > Settings > Team, or be an administrator.",
          accessDeniedP2:
            "Flow: Register the user first → then link them as Professional under Team.",
          goHome: "Go to home",
          checkingAccess: "Checking access…",
          allProfessionals: "All professionals",
        },
        status: {
          all: "All",
          pending: "Pending",
          confirmed: "Confirmed",
          rescheduled: "Rescheduled",
          in_progress: "In progress",
          completed: "Completed",
          no_show: "No-show",
          cancelled: "Cancelled",
        },
        calendar: {
          date: "Date",
          time: "Time",
          event: "Event",
          today: "Today",
          previous: "Previous",
          next: "Next",
          month: "Month",
          week: "Week",
          day: "Day",
          agenda: "Agenda",
          noEventsInRange: "No appointments in this range.",
          noName: "No name",
          serviceFallback: "Service",
          code: "Code",
          detailsListTitle: "Appointment details",
          viewDetails: "View details",
          modality: {
            presencial: "In person",
            online: "Online",
            phone: "Phone",
          },
        },
        dashboard: {
          wd0: "Mon",
          wd1: "Tue",
          wd2: "Wed",
          wd3: "Thu",
          wd4: "Fri",
          wd5: "Sat",
          wd6: "Sun",
          kpiWeek: "Sessions this week",
          kpiPending: "Awaiting confirmation",
          kpiToday: "Sessions today",
          kpiRate: "Attendance rate (30 days)",
          chartTitle: "Sessions per day — {{month}}",
          todayTitle: "Today’s sessions",
          todayEmpty: "No sessions scheduled for today",
          todayLine: "{{time}}: {{contact}} — {{service}}",
          professionalPrefix: "Professional:",
          upcomingTitle: "Upcoming sessions",
          upcomingEmpty: "No sessions scheduled in the next 30 days",
          chartConfirmed: "Confirmed",
          chartPending: "Pending",
          chartCancelled: "Cancelled",
          code: "Code",
          viewDetails: "View details",
          modality: {
            presencial: "In person",
            online: "Online",
            phone: "Phone",
          },
        },
        pendientes: {
          loading: "Loading...",
          emptyHint: "These requests need your confirmation before they are scheduled",
          emptySub: "No pending requests",
          intro: "These requests need your confirmation before they are scheduled",
          noName: "No name",
          serviceFallback: "Service",
          instructor: "Instructor: {{name}}",
          chipPending: "Pending",
          confirm: "Confirm",
          reschedule: "Reschedule",
          cancel: "Cancel",
          tooltipConfirm:
            "The appointment is confirmed, appears on the calendar and leaves Pending",
          tooltipReschedule: "Opens the modal to change appointment status (e.g. confirm, cancel)",
          tooltipCancel: "Cancels the appointment; it will no longer appear in Pending",
          code: "Code",
          bookedByAi: "Booked by AI",
          notes: "Notes",
          modality: {
            presencial: "In person",
            online: "Online",
            phone: "Phone",
          },
        },
        historial: {
          loading: "Loading history…",
          empty: "No appointments match the filters",
          emptyHint: "Adjust dates or status in the header to see more results",
          countOrder: "{{count}} appointments · Sort: {{order}}",
          orderAsc: "soonest first",
          orderDesc: "most recent first",
          changeOrder: "Change sort order",
          edit: "Edit",
          editReschedule: "Edit / Reschedule",
          editAria: "Edit appointment",
          tableAria: "Appointment history",
          colDate: "Date",
          colTime: "Time",
          colContact: "Contact",
          colService: "Service",
          colProfessional: "Professional",
          colDetails: "Details",
          colStatus: "Status",
          colActions: "Actions",
          code: "Code",
          modality: {
            presencial: "In person",
            online: "Online",
            phone: "Phone",
          },
          rowsPerPage: "Rows per page:",
          rowsPerPageShort: "Rows:",
          displayedRows: "{{from}}-{{to}} of {{count}}",
        },
        config: {
          firstTimeTitle: "First time setting up Agenda?",
          firstTimeSubtitle: "Set up profile, services, team and business hours in a few steps.",
          firstTimeCta: "Start here",
          activeProfileTitle: "Active profile: {{name}}",
          activeProfileSubtitle: "Change any part of your initial setup.",
          cardPerfilTitle: "Business type / profile",
          cardPerfilDesc:
            "Define whether you are Beauty, Sales, Health, Education or Technical. Affects wording and Kanban columns.",
          cardServiciosTitle: "Services / programs",
          cardServiciosDesc: "Catalog of services, subjects or programs with duration and price.",
          cardEquipoTitle: "Instructor team",
          cardEquipoDesc:
            "Professionals who serve customers. Link each one to a user so they can access Agenda and confirm appointments.",
          cardHorariosTitle: "Business hours",
          cardHorariosDesc: "Days, hours and slot duration per day.",
          cardSecuenciasTitle: "Automatic AI Agent sequences",
          cardSecuenciasDesc:
            "When and how the AI Agent captures data and triggers flows (appointment request). Tone is configured in AI Prompts.",
          equipoIntro:
            "Link each professional to a user (from Users) so they can open Agenda and confirm appointments.",
          equipoConfigureBtn: "Configure team (names, roles and specialties)",
          loadingProfessionals: "Loading professionals…",
          tableProfessional: "Professional",
          tableRole: "Role / specialty",
          tableLinkUser: "Link to user",
          noneUser: "— None —",
          noProfessionals:
            "No professionals yet. Use the button above to add the team in initial setup.",
          secuenciasIntro:
            "Choose which AI Agent (Prompt) is used to capture appointment requests in chat. Tone and personality are set on that agent.",
          loading: "Loading…",
          agentLabel: "AI Agent for appointment flow",
          noAgent: "— None (don’t use an Agent for appointments) —",
          noAgentsList: "No AI Agents. Create one under AI Prompts.",
          promptsLink: "Configure tone and personality in AI Prompts",
          kanbanHint:
            "If you changed business type, recreate Kanban columns for the current profile.",
          kanbanRecreate: "Recreate Kanban columns",
          kanbanProcessing: "Processing…",
          edit: "Edit",
          editSectionAria: "Edit {{section}}",
          toastLinkOk: "Link updated. The instructor can access Agenda with their user.",
          toastKanbanOk: "Kanban columns recreated for the profile.",
          toastAgentOk: "AI Agent for appointment flow updated.",
          errorProfileFirst: "Configure the profile in initial setup first.",
        },
        appointmentModal: {
          titleNew: "New appointment",
          titleEdit: "Appointment {{code}}",
          detailsTitle: "Appointment details",
          contactFallback: "Contact #{{id}}",
          client: "Client:",
          service: "Service:",
          professional: "Professional:",
          date: "Date:",
          confirmationCode: "Confirmation code",
          statusLabel: "Status",
          viewProfile360: "View 360 profile",
          rescheduleHint:
            "Enter the new date, service and professional to reschedule. A notification will be sent to the contact.",
          newDateTime: "New date & time *",
          duration: "Duration (minutes)",
          modality: "Modality",
          modalityPresential: "In person",
          modalityOnline: "Online",
          modalityPhone: "Phone",
          locationDetail: "Location / link",
          locationPlaceholder: "Address, room or meeting link",
          notes: "Notes",
          bookedByAi: "Booked by AI",
          createdAt: "Created",
          updatedAt: "Updated",
          yes: "Yes",
          no: "No",
          introNew:
            "Register a new appointment manually. Type to search and pick from the filtered list.",
          contactLabel: "Contact *",
          contactPlaceholder: "Type name or number to search…",
          contactHelper: "Required. Search by name or phone.",
          noOptionsShort: "Type at least 2 characters to search",
          noOptionsEmpty: "No results",
          connectionLabel: "Connection *",
          connectionPlaceholder: "Select the WhatsApp line (connection) for this appointment",
          connectionHelper:
            "Required. The connection under which the appointment is stored (same logic as scheduled reminders).",
          connectionNamed: "Connection {{id}}",
          dash: "—",
          serviceField: "Service",
          serviceSearchPh: "Search service…",
          serviceHelper: "Optional. Service catalog.",
          noServices: "No services configured",
          professionalField: "Professional",
          professionalSearchPh: "Search professional…",
          professionalHelper: "Optional. Instructor team.",
          noProfessionalsConfigured: "No professionals configured",
          datetimeLabel: "Date & time *",
          datetimeHelper: "Required. Appointment time.",
          durationHelper: "Default 60 minutes.",
          notesPlaceholder: "Additional notes…",
          cancel: "Cancel",
          saveReschedule: "SAVE & RESCHEDULE",
          saveStatus: "Save status",
          create: "Create appointment",
          toastContactDateRequired: "Contact and date are required",
          toastWhatsappRequired: "Select the WhatsApp connection for the appointment",
          toastStatusUpdated: "Status updated",
          toastCreated: "Appointment created",
          toastRescheduleDateRequired: "New date is required to reschedule",
          toastRescheduled: "Appointment rescheduled. Notification sent to the contact.",
        },
      },
      negocioModule: {
        mobileNav: {
          label: "Business shortcuts",
          home: "Home",
          customers: "Customers",
          services: "Services",
          collections: "Collections",
        },
        title: "Business",
        previewOnly: "Visible only to the system owner · under construction",
        loading: "Loading…",
        search: "Search…",
        empty: "No records yet. Create the catalog and accounts to start selling.",
        save: "Save",
        close: "Cancel",
        edit: "Edit",
        cancel: "Cancel",
        renew: "Renew",
        markPaid: "Mark as paid",
        toastSaved: "Saved",
        phoneFormat: "Country code and local number, without spaces.",
        confirmTitle: "Confirm",
        confirmBody: "Are you sure you want to continue?",
        deleteAccountBody: "The account and all its profiles will be deleted. Only allowed if the account has expired (or has no expiry date) and no customer has an active service on it.",
        confirmRemoveService: "Are you sure you want to delete this record?",
        removeService: "Remove",
        due: {
          leftN: "{n} days left",
          tomorrow: "Due tomorrow",
          today: "Due today",
          expiredN: "Expired {n} days ago",
          expiredOne: "Expired 1 day ago",
        },
        openInfo: "View details",
        related: {
          accounts: "View accounts",
          products: "View products",
          sales: "View movements",
          collections: "View collections",
          services: "View services",
          customers: "View customer",
          suppliers: "All suppliers",
          combos: "View combos",
        },
        filters: { all: "All" },
        pager: {
          rows: "Rows",
          shown: "{from}–{to} of {count}",
        },
        pages: {
          growth: {
            title: "Referrals and sales recovery",
            referralEnabled: "Referral program active",
            referralHint: "Each customer gets a link (/invitar on Telegram or INVITAR on WhatsApp). When a new friend pays their first purchase, the referrer gets the reward once.",
            rewardType: "Reward type",
            rewardWallet: "Wallet balance",
            rewardPoints: "Points",
            rewardAmount: "Reward for the referrer",
            rewardAmountHintWallet: "Amount in wallet currency ({cur}).",
            rewardMode: "Reward type",
            rewardModeFixed: "Fixed amount ({cur})",
            rewardModePercent: "% of first purchase",
            rewardPercentHint: "Percentage of the invited friend's first paid purchase.",
            rewardPercentExample: "Example: if the friend buys {sale}, the referrer gets {pct}% = {wallet} of balance (customers abroad: ≈ {fx}).",
            rewardFixedExample: "The referrer gets {amount} of balance for each friend who buys (customers abroad: ≈ {fx}).",
            rewardAmountHintLocal: "Amount in {cur}. Customers abroad get the equivalent in foreign currency.",
            rewardZeroWarning: "With a 0 reward the program is off: no invite links are shared and the AI agent won't invite referrals.",
            rewardAmountHintPoints: "Number of points.",
            friendReward: "Welcome bonus for the invitee (optional)",
            friendRewardHint: "0 = no bonus. Credited with their first paid purchase.",
            cartEnabled: "Abandoned cart reminder",
            cartHint: "A gentle reminder to customers with an unpaid order (after 45 min) and, on Telegram, to those who viewed a product without buying (after 2 h). At most once a day, outside night hours.",
            autoRenewEnabled: "Auto-renew with balance",
            autoRenewHint: "Customers turn it on by typing AUTORENOVAR (or from their profile). On the expiry day it's charged from their balance only if it's enough and their balance is enabled; otherwise they're notified. No cashback.",
            autoRenewNeedsWallet: "Requires the balance/cashback system to be on.",
            reactivationEnabled: "Win back inactive customers (premieres and trends)",
            reactivationDays: "At most 1 message every (days)",
            reactivationHint: "The AI agent writes to customers without an active service with 2 trending titles from platforms you have in stock. Requires AI and TMDB API keys. Few per hour, 10:00 to 19:00.",
            supportTitle: "Guarantee, support and stock",
            guaranteeHours: "Replacement guarantee (hours)",
            supportResponseText: "Support response time",
            supportResponsePlaceholder: "E.g.: we reply in under 30 minutes (8 am – 10 pm)",
            stockAlertDays: "Stock alert (days of coverage)",
            stockAlertHint: "0 = off",
            supportHint: "The guarantee and response time are shown to customers when they report a fault or ask for an agent, and the AI agent knows them. The stock alert notifies the admin (WhatsApp/Telegram) when, at the 14-day sales pace, free stock covers that many days or fewer.",
            save: "Save",
            statsTitle: "Results (last {days} days)",
            promoSent: "Promos sent",
            promoClicks: "View details clicks",
            promoPaid: "Attributed sales",
            promoRevenue: "Attributed revenue",
            invited: "Invited",
            converted: "Purchased",
            colPromo: "Promotion",
            colSent: "Sent",
            colClicks: "Clicks",
            colPaid: "Sales",
            colRevenue: "Revenue",
            colReferrer: "Customer",
            colCode: "Code",
            topReferrers: "Top referrers",
            promosTitle: "Latest Telegram promotions",
            empty: "No data yet.",
          },
          ai: {
            tab: "AI Agent",
            hint: "AI agent that handles support and sales on WhatsApp and Telegram using real Negocio data, and learns from your agents.",
            title: "AI support & sales agent",
            intro: "When enabled, the agent replies in natural language: checks the customer's services and due dates, recommends catalog products with real price and stock, starts purchases with payment (including automatic Binance Pay), looks up codes, guides troubleshooting and hands off to a human when needed. Buttons, commands (MENU, SOPORTE, CODIGO) and payment steps keep working. If a human takes the chat, the agent stops.",
            enabled: "AI agent enabled",
            needKey: "API Key missing: without it the agent won't reply and the guided bot keeps answering.",
            provider: "Provider / model",
            apiKey: "Provider API Key",
            apiKeySet: "Key saved. Type a new one only to change it.",
            apiKeyHint: "OpenAI (sk-...), Google AI Studio, Anthropic or OpenRouter key depending on provider.",
            tmdbKey: "TMDB key (recommendations)",
            tmdbKeyHint: "Optional. With your themoviedb.org API key the agent recommends trending movies and series and where to watch them.",
            model: "Custom model (optional)",
            modelHint: "Leave empty to use the provider default.",
            agentName: "Agent name",
            temperature: "Creativity (0 to 1)",
            temperatureHint: "0.3–0.5 recommended.",
            history: "Memory messages",
            historyHint: "How many previous chat messages it remembers.",
            instructions: "Business instructions",
            instructionsPlaceholder: "E.g.: Support hours 9am–10pm. Warranty: account replacement if it fails while valid...",
            instructionsHint: "Policies, tone, hours and your own rules. The agent already knows catalog, prices, stock, payment methods, terms and each customer's services.",
            autoLearn: "Self-learning",
            autoApprove: "Publish learned knowledge without review",
            vision: "Analyze images",
            visionHint: "The agent reads images sent by customers: detects payment receipts vs. error screenshots, extracts the Binance Order ID to validate payments automatically and attaches a summary to the payment alert. Requires a vision model (e.g. GPT-4o / GPT-4o mini).",
            adminDigest: "Admin assistant and reminders",
            adminDigestHint: "When the bot admin (WhatsApp number or Telegram user from Settings › Bot) writes, the agent answers as their assistant: pending tickets, expired accounts, payments, appointments and WaToolX how-to questions based on their plan. It also sends the day's pending items at 8:00 and 15:00.",
            autoLearnHint: "When the agent hands a case to a human, it later analyzes how the human solved it and creates reusable knowledge (no personal data). Without auto-publish they stay Pending for your approval.",
            testTitle: "Test the agent",
            testHint: "Chat as a customer. Actions (purchases, flows, handoffs) are shown but not executed. Save settings before testing.",
            testEmpty: "Type a message to start.",
            testPlaceholder: "Type as a customer…",
            resetChat: "Reset",
            knowledgeTitle: "Knowledge base",
            knowledgeHint: "Answers, solutions and policies the agent uses. Learned ones arrive as Pending until approved.",
            knowledgeEmpty: "No entries yet.",
            newEntry: "New entry",
            editEntry: "Edit entry",
            learnHistory: "Learn from history (30 days)",
            learnNow: "Process handoffs",
            learnDone: "Reviewed {reviewed} conversations · {learned} new entries",
            question: "Question or situation",
            questionHint: "How a customer would ask it.",
            answer: "Answer / solution",
            tags: "Tags",
            tagsHint: "Comma-separated keywords",
            status: "Status",
            statusActive: "Active",
            statusPending: "Pending",
            statusDisabled: "Disabled",
            source: "Source",
            sourceLearned: "Learned",
            sourceManual: "Manual",
            uses: "Uses",
            approve: "Approve",
            filterAll: "All",
            confirmDelete: "Delete this entry?",
            statActive: "Active entries",
            statPending: "To approve",
            statLearned: "Learned",
            statEscalations: "Handoffs (30 days)",
          },
          dashboard: {
            title: "Overview",
            subtitle: "Profit, expirations and sales.",
            today: "Today",
            setup: "How to set up the business",
            step: "Step",
            open: "Open",
            profit: "Profit",
            monthResume: "Month summary",
            vsPrev: "vs. previous period",
            expiredBanner: "{n} profile(s) already expired",
            expiringBanner: "{n} profile(s) expire in the next 3 days",
            pendingBanner: "{n} sale(s) pending payment",
            toRenew: "to renew · click to view",
            toCollect: "to collect · click to view",
            profitByMonth: "Profit by month",
            rangeTotal: "Range total",
            bestMonth: "Best month",
            worstMonth: "Lowest month",
            byService: "Summary by service",
            thisMonth: "This month",
            salesCount: "sale(s)",
            noServices: "No product sales this month yet.",
            raffleTitle: "Monthly raffle",
            raffleWinner: "Winner for {month}: {name}",
            rafflePhone: "Phone {phone}",
            raffleTickets: "{n} of {total} tickets",
            rafflePending: "Prize pending redemption · expires {date}",
            raffleRedeemed: "Prize redeemed on {date}",
            raffleExpired: "Prize expired without redemption",
          },
          subscriptions: {
            title: "Collections",
            subtitle: "Services due in 3 days, due today, or already expired.",
            emptyTitle: "Nothing due right now",
            empty: "When a service is 3 days out, due today, or already expired, it shows up here.",
            search: "Search by name or code…",
            pendingShort: "to collect",
            expiredShort: "expired",
            expiredOverdue: "{count} expired for more than {days} days",
            soonShort: "in 3 days",
            todayShort: "today",
            sendReminders: "Send reminders",
            remindersSent: "Reminder send started ({n}).",
            remindersReport: "Reminders: {sent} message(s). {detail}",
            remindersRunning: "A reminder run is already in progress.",
            exportReport: "Export report",
            kpis: {
              amount: "In queue",
              soon: "In 3 days",
              today: "Due today",
              expired: "Expired",
              pending: "Pending",
              debtors: "Debtors",
            },
          },
          services: {
            title: "Services",
            subtitle: "Live cart per customer. Add, renew or remove. Same records as the full portfolio list.",
            emptyTitle: "No live services yet",
            empty: "Add a product to a customer. It stays in their cart and is also recorded in Movements.",
            search: "Search customer or service…",
            overdueBy: "{n}d overdue",
            daysLeft: "{n} days",
            view: {
              cart: "By customer",
              list: "List",
            },
            kpis: {
              clients: "Customers",
              live: "Services",
              expired: "Expired",
              pending: "Unpaid",
            },
            cart: {
              new: "New cart",
              config: "Settings",
              pickCustomer: "Customer",
              payment: "Payment method",
              payment2: "Second payment method",
              payment2Hint: "Optional. Up to two methods per customer.",
              saleType: "Sale type",
              saleTypes: {
                profile: "Profile",
                full: "Full account",
                combo: "Combo",
              },
              saleTypeHints: {
                profile: "Only accounts sold by profile.",
                full: "Only accounts sold as a full account.",
                combo: "Combos first, then every available account.",
              },
              codes: "Code system",
              codeUrl: "URL",
              codeUser: "Username",
              codePassword: "Password",
              addItem: "Add service",
              noItems: "This cart has no services yet.",
              pickAccount: "Select a product and account.",
              pickProfile: "Select a profile.",
              comboUnavailable: "There are no free accounts for every combo product.",
              comboHint: "Saving assigns a free account to each combo product.",
              reviewSlots: "Combo accounts and profiles",
              reviewSlotsHint: "Picked at random. Open them to change before saving.",
              shuffleSlots: "Shuffle again",
              remove: "Delete cart",
              removeBlocked: "You can only delete a cart with no live services.",
              sendOrder: "Order",
              sendReminder: "Reminder",
              sendUpdated: "Updated (5 min)",
              sendLast: "Last order (5 min)",
              sendRenewed: "Renewal (5 min)",
              renewExpired: "Renew expired",
              renewExpiredOk: "Services renewed",
              pointsAccumulated: "Accumulated points",
              cartTotal: "Purchase total",
              currency: "Currency",
              currencyLocal: "Primary currency",
              currencyFx: "FX",
              profit: "Profit",
              profitHint: "Price minus cost, always in the primary currency.",
              fxLocalHint: "Equivalent in primary currency",
              contractDate: "Contract date",
              details: "Service details",
              itemCodes: "Code system",
              paid: "Paid",
              unpaid: "Unpaid",
              payWithWallet: "Pay with balance",
              payWithWalletHint: "Deducted from the customer's wallet in their currency. If it's not enough, nothing is registered. Paying with balance earns no cashback.",
              walletPaid: "Will be paid with the customer's balance",
              payWithPrize: "Redeem raffle prize",
              payWithPrizeHint: "30 days of a service with stock. Expires on {date}. Requires an active current service.",
              prizeDaysHint: "The prize grants 30 days. Ends",
              prizePaid: "Prize redemption (recorded as a negative amount)",
              prizeReady: "Prize ready to redeem",
              ticketsLabel: "Tickets",
              raffleTickets: "{n} tickets this month",
              sendPay: "Payment reminder",
              send: "Send",
              suggestedAccount: "Suggested: a free profile was picked at random; you can change it.",
              codePoolHint: "Leave empty to take one code from stock ({n} available).",
              panelStockHint: "Paste the code or link created when associating. {n} left on this account.",
            },
          },
          sales: {
            title: "Movements",
            subtitle: "Every collection stays here. Removing a service does not delete it.",
            emptyTitle: "No movements yet",
            empty: "Adding a service to a cart also records the collection here.",
            search: "Search customer or service…",
            export: "Export CSV",
            filterProduct: "Product",
            filterCustomer: "Customer",
            filterPayment: "Payment method",
            dateFrom: "From",
            dateTo: "To",
            pickMonth: "Month",
            pickYear: "Year",
            chartTrend: "By month",
            chartByType: "By type",
            chartByProduct: "By product",
            chartByCustomer: "By customer",
            chartByPayment: "By payment method",
            chartClick: "Click to filter · click again to clear",
            chartClientsN: "{n} customers",
            chartClientsTop: "Top {n}",
            chartClientsMore: "+{n} more in the table",
            chartOther: "Other",
            kpis: {
              today: "Today",
              week: "This week",
              month: "This month",
              year: "This year",
              historical: "All-time total",
              count: "Movements",
              filterIncome: "Income (filter)",
              filterPending: "Unpaid (filter)",
              filterCount: "Movements (filter)",
              filterAvg: "Average ticket",
            },
            types: {
              sale: "Income",
              pending_payment: "Unpaid",
              redeem: "Points redemption",
            },
            periods: {
              all: "All",
              today: "Today",
              week: "Week",
              month: "Month",
              year: "Year",
            },
          },
          customers: {
            title: "Customers",
            subtitle: "Address book with WhatsApp photo, code and services.",
            agendaSubtitle: "Address book with WhatsApp photo, code and services.",
            emptyTitle: "No business customers yet",
            empty: "Add them manually or they will appear when you record a sale.",
            active: "Services",
            noServices: "This customer has no subscriptions yet.",
            noSales: "This customer has no purchases yet.",
            phoneHint: "Country code and number, no + or spaces. Example: 573001234567",
            telegramHint: "Telegram username, without @. Required if there is no phone.",
            phoneOrTelegram: "Enter a phone number or Telegram.",
            nameRequired: "Name is required",
            unknownCountry: "Country not identified",
            openDetail: "Open profile",
            newTicket: "Start conversation",
            openChat: "Go to conversation (opens the existing one or starts one)",
            detailTitle: "Customer profile",
            points: "Points",
            pointsOn: "Gets cashback",
            sendWallet: "Send balance to customer",
            autoRenewOn: "Auto-renews with balance",
            autoRenewOff: "No auto-renew",
            discountPercent: "Discount % (reseller)",
            discountHint: "Applies to new purchases in the bot, the AI and panel sales. Not applied to renewals. Rounded to the nearest hundred.",
            metrics: {
              avgTicket: "Average ticket",
              lastPurchase: "Last purchase",
              daysAgo: "{n} days ago",
              frequency: "Frequency",
              everyDays: "every {n} days",
              churn: "Churn risk",
              risk: { alto: "High", medio: "Medium", bajo: "Low" },
              autoRenew: "Auto-renew",
              yes: "Yes",
              no: "No",
            },
            pointsOff: "No cashback",
            walletCurrency: "Balance & cashback currency",
            walletCurrencyHint: "Cashback uses the general % of what the customer pays and is credited in this currency.",
            walletCurrencyConvert: "Their current balance of {{from}} will be converted to {{to}} (rate {{rate}}).",
            wallet: "Balance",
            walletHistory: "Wallet movements",
            walletEmpty: "This customer has no balance movements.",
            walletAmount: "Amount",
            walletReasons: {
              recarga: "Top-up",
              compra: "Purchase",
              renovacion: "Renewal",
              ajuste: "Manual adjustment",
              reembolso: "Refund",
              referido: "Referral",
              cashback: "Cashback",
              puntos: "Points conversion",
            },
            sales: "Purchase history",
            purchases: "Purchases",
            totalPurchases: "Total purchases",
            pointsHistory: "Points history",
            pointsEmpty: "This customer has no point movements.",
            pointsService: "Service",
            pointsReason: "Reason",
            pointsPurchase: "Purchase",
            pointsRedeem: "Redeem",
            services: "Acquired services",
            registeredAt: "Customer since",
            renewStartHint: "The day after the previous expiry, to keep continuity.",
            sendUpdated: "Send updated details",
            sendRenewed: "Send renewal message",
            sendRenewTitle: "Send the renewal message?",
            sendRenewBody: "The service was renewed. You can notify the customer now via WhatsApp or Telegram, or skip this step.",
            sendPromptTitle: "Send the message?",
            sendPromptBody: "Send it now via WhatsApp or Telegram, or skip this step.",
            sendNewServiceTitle: "Send the new service details?",
            sendNewServiceBody: "This message includes access or invite details for the products you just added. If you add more, they all go in the same send. The full-cart summary is sent with Order.",
            sendSkip: "Not now",
            sendingVia: "Sending via {channel}…",
            addAnotherProduct: "Add another product",
            createSaleTitle: "Create a sale?",
            createSaleBody: "The customer is ready. Do you want to open a cart and sell now?",
            createSaleYes: "Yes",
            createSaleNo: "No",
            addProductsTitle: "Add products?",
            addProductsBody: "The cart is configured. Do you want to add products now?",
            addProductsYes: "Yes",
            addProductsNo: "No",
            swapProfile: "Swap profile",
            swapProfileTitle: "Move to another account?",
            swapProfileBody: "Another account of the same product with a free slot (profile, member or device) will be assigned, without a new sale. Useful if the platform kicked the user.",
            swapProfileOk: "Account and slot swapped",
            markedPaid: "Marked as paid",
            markPaidBody: "The payment will be marked as received and the service will become active.",
            payWithWallet: "Pay with balance",
            payWithWalletBody: "The sale amount will be deducted from the customer's balance and the service will become active. Paying with balance earns no cashback.",
            paidWithWallet: "Sale paid with the customer's balance",
            removeServiceTitle: "Remove service",
            removeServiceBody: "Are you sure you want to delete this record?",
            sentOk: "Message sent",
            sendPointsTip: "Tap to send the wallet balance to the customer",
            walletHistoryCurrencyHint: "Movements without a recorded currency show only the original amount.",
            sendPointsTitle: "Send wallet balance:",
            templatesLink: "Edit template",
            types: {
              final: "Customer",
              reseller: "Reseller",
            },
            import: {
              action: "Import",
              title: "Import customers from CSV",
              formatTitle: "Expected format",
              formatSample: "nombre,prefijo,telefono,tipo,email\nJuan Pérez,+57,3001234567,client,juan@example.com\nMaría López,+52,5512345678,client,\nPedro Gómez,+57,3119876543,reseller,",
              ruleName: "name: 2-150 characters",
              rulePrefix: "prefix: + and 1-4 digits (e.g. +57)",
              rulePhone: "phone: 6-30 digits (dashes/spaces are stripped)",
              ruleType: "type: client or reseller",
              ruleEmail: "email: optional, leave empty if not used",
              ruleDupes: "Rows with duplicate phones or emails are skipped",
              ruleMax: "Maximum 1000 rows per import",
              pickFile: "Select a file",
              dropHint: "CSV up to 5 MB. Invalid rows are skipped.",
              empty: "The file has no valid rows.",
              maxSize: "The file cannot exceed 5 MB.",
              done: "Synced {created} customers. Skipped: {skipped}.",
            },
            kinds: {
              active: "With service",
              expiring: "Expiring",
              expired: "Expired",
              none: "No services",
            },
          },
          accounts: {
            title: "Accounts",
            subtitle: "Email, free or occupied profiles, and expiry.",
            emptyTitle: "No accounts in inventory",
            empty: "Create a product first. Then add the account; profiles are created as free when applicable.",
            profiles: "Profiles on this account",
            noProfiles: "This account has no profiles yet.",
            fullHint: "Full-account sale: no profiles are used.",
            fullHintMailbox: "Each mailbox is one unit. There is no profile grid: the Gmail/Outlook is delivered whole.",
            slotsFromProduct: "Taken from the product’s slot cap (profiles, members or devices).",
            slotsEditableHint: "Saving creates any missing slots so they can be sold or edited.",
            profileNameHint: "Saved as “name 1”, “name 2”, …",
            endDateHint: "Calculated from the contract date and plan days.",
            profilePriceHint: "Account sale price divided by the number of profiles.",
            editProfile: "Edit profile",
            editSlot: "Edit slot",
            seeAllProfiles: "See all",
            generatePin: "Generate PIN",
            overdue: "Expired",
            expiredBlocksAvailable: "An expired account cannot be available. Renew the dates or set it to fault/idle.",
            botPublish: "Publish in the bot store",
            botPublishHint: "When on, the WhatsApp/Telegram bot can sell this account if free stock remains.",
            botPublishBlocked: "Fault or idle accounts cannot be published in any store.",
            siteLoginHint: "Create the slots, then edit each one to set the customer site URL, username and password.",
            deleteSlot: "Delete slot",
            deleteSlotConfirm: "Delete this free slot? This cannot be undone.",
            deleteSlotBusy: "Only free slots (no customer) can be deleted.",
            allProducts: "All services",
            allSuppliers: "All suppliers",
            allCountries: "All countries",
            filterService: "Service",
            filterSupplier: "Supplier",
            filterCountry: "Country",
            emailsBulkHint: "One email per line. Optional: email,password. Lot cost is split across units.",
            lotHint: "If you bought a lot (e.g. 10 mailboxes), note how many units the cost covers.",
            unitCost: "Cost per unit",
            remainingOne: "1 day",
            remainingN: "{n} days",
            daysOf: "{left} of {total} days",
            stock: "Stock",
            orders: "Orders",
            detail: "Account details",
            accountSales: "Sales on this account",
            noSales: "There are no sales on this account yet.",
            updateNotifyTitle: "Send update to clients?",
            updateNotifyBody:
              "There are {count} service(s) on this account. The update message will be sent via WhatsApp first, and also via Telegram when available.",
            updateNotifySend: "Send now",
            updateNotifyDone: "Update sent: {sent} message(s) for {total} client(s).",
            filters: {
              available: "Available",
              occupied: "Sold",
              expiring: "Expiring",
              expired: "Expired",
              fault: "Fault",
              pending: "Pending",
              renew: "To renew",
            },
            import: {
              action: "Import",
              title: "Import accounts",
              formatTitle: "CSV with header. Example:",
              formatSample: "product,email,password,cost,price,start,days,type,supplier",
              ruleProduct: "product must match an existing product name.",
              ruleEmail: "email and password are required.",
              rulePass: "type: profile or full.",
              ruleOptional: "Optional: cost, price, start (YYYY-MM-DD), days, slots, supplier, url, ip, country, pin.",
              ruleDupes: "Same email on the same product is skipped.",
              ruleMax: "Max 500 rows per file.",
              pickFile: "Choose CSV file",
              dropHint: "CSV or comma/semicolon-separated text.",
              empty: "The file has no valid rows.",
              maxSize: "File exceeds 5 MB.",
              done: "Imported {created}. Skipped {skipped}.",
            },
            saleTypes: {
              profile: "Sell by profile",
              profileHint: "Free profiles are created to sell one by one.",
              member: "Sell by member",
              memberHint: "Members are invited one by one, with no PIN.",
              device: "Sell by device",
              deviceHint: "Each slot is a device. You cannot assign more than the cap.",
              full: "Full account",
              fullHint: "The whole account is sold, with no profiles.",
            },
            profileStatus: {
              available: "Free",
              occupied: "Occupied",
            },
            durations: {
              14: "14 days",
              20: "20 days",
              30: "1 month",
              60: "2 months",
              90: "3 months",
              180: "6 months",
              365: "1 year",
            },
            billingType: {
              title: "Billing type",
              hintAutopay: "Self-renewing: it does not cost each month and renews on its own. It keeps working even if days go negative. You can note a one-time acquisition cost or leave it empty.",
              hintCost: "Cost-based: you buy it from a supplier and renew it each month for a fee. We notify you when it expires so you can renew it.",
              autopay: "Self-renewing",
              autopaySub: "Renews on its own",
              cost: "Cost-based",
              costSub: "You renew each month",
              unlimited: "Unlimited — it renews on its own, there is no date to track.",
              unlimitedShort: "Unlimited",
            },
            costAutopay: "Cost (optional · one-time)",
            costMonthly: "Cost (monthly renewal)",
            pinDisabledHint: "This account will have profiles without PINs.",
            currencyHint: "You can enter purchase or sale in the primary currency or the FX. Both are always stored and shown.",
            salePrice: "Sale price",
            salePriceHint: "What you charge the customer for this account. Type it in primary currency or FX; both are always stored and shown.",
            purchaseCost: "Purchase cost",
            purchaseCostHint: "What you pay the supplier when you buy or renew this account. If you pay the same every month, the renewal cost is this same amount.",
            unitCost30: "30-day sale cost",
            unitCost30Hint: "Purchase cost brought to 30 days, then divided by the number of profiles. If the account is paid yearly, get the 30-day cost first, then divide.",
            suggestedSale: "Suggested price ({pct}% profit): {price}",
            deviceLimitHint: "Only for device products (CapCut, IPTV). How many devices this account holds. It does not apply to Netflix-style full-account sales.",
            licenseCount: "Available codes or links",
            licenseCountHint: "How many codes or links remain on this panel account. They decrease on each sale.",
            autopayDurationHint: "Used to calculate the 30-day cost. The account itself does not expire.",
          },
          products: {
            title: "Products",
            subtitle: "Catalog: delivery, plan and warranty. The customer price is set on each account.",
            emptyTitle: "Create the first product",
            empty: "Example: Netflix. Then you assign accounts and profiles.",
            namePlaceholder: "E.g. Netflix, Disney+, HBO Max…",
            noDescription: "No description",
            announce: {
              action: "Notify customers",
              title: "Message to product customers",
              hint: "Announce outages, price changes, new terms, or any formatted message. Sent via WhatsApp or Telegram per customer.",
              onlyActive: "Only customers with an active service",
              loadingAudience: "Counting recipients…",
              audience: "{total} recipients ({wa} WhatsApp · {tg} Telegram)",
              message: "Message",
              empty: "Write the message before sending",
              send: "Send notice",
              sending: "Sending…",
              sent: "Notice sent to {sent} of {total} customers",
              partialErrors: "{n} sends failed (check logs)",
            },
            preset: "Set up as…",
            presetHint: "The model stays selected and fills sale type, slots and caps.",
            giftCardCostHint: "What you pay per code. Enter it in the primary currency or the FX; both are stored.",
            giftCardPriceHint: "What you charge per code. Enter it in the primary currency or the FX; both are stored.",
            openSite: "Open product site",
            serviceUrlHint: "Clicking the logo opens this URL to sign in.",
            botSellable: "Sell via bot (WA / Telegram)",
            activationMode: "Activation after payment",
            activationModeHint: "Manual: the bot alerts admin even when Binance confirms payment.",
            activationAuto: "Automatic (deliver account)",
            activationManual: "Manual (agent activates)",
            slotKind: "What space is sold",
            availableShort: "{n} avail.",
            managePlans: "Manage plans in Settings",
            planHint: "Pick a plan or type a new one below.",
            addPlanInline: "New plan",
            addPlanInlineBtn: "Add plan",
            addPlanInlineHint: "Saved to the catalog and available immediately.",
            createAccounts: "Create account(s)",
            createAccountsHint: "Opens inventory form for this product (one or several).",
            addAnotherAccountTitle: "Create another account?",
            addAnotherAccountBody: "The account was saved. Add another for this product?",
            addAnotherAccountYes: "Yes, another",
            addAnotherAccountNo: "Done",
            ownership: {
              title: "Sale type",
              hint: "Rental: the client uses email and password from inventory. Domain: the service is delivered to the client’s email. Full: the whole account is delivered, with no profiles.",
              rental: "Rental",
              rentalHint: "Shared account: email, password and profile. You can also sell the full account from each inventory unit.",
              domain: "Domain",
              domainHint: "Sold to the client’s email (invite or member). The master password is not shared.",
              full: "Full account",
              fullHint: "Email and password of the whole account are delivered. No profiles or PIN.",
            },
            presets: {
              streaming: "Streaming with profiles (Netflix, Max, Disney)",
              fullAccount: "Full account (email and password, no profiles)",
              iptv: "IPTV / Flujo (username, password and URL)",
              hostingSites: "Hosting / websites (parent account + slots with URL, user and password)",
              family: "Family invite (Spotify, YouTube)",
              canvaEdu: "Canva EDU / email member",
              capcut: "By devices (CapCut)",
              code: "Code or link (VPN, AI, PIN top-ups)",
              panel: "Codes or links generated when associating (panel)",
              recharge: "Top-up by ID (Free Fire)",
              mailbox: "Standalone emails (Gmail, Outlook)",
            },
            fulfillment: {
              title: "How it is delivered",
              credentials: "Rental (email and password)",
              invite: "Domain (to the client’s email)",
              code: "Code or link",
              panel: "Panel",
              device: "By devices",
              recharge: "Top-up to an ID",
              mailbox: "Delivered mailbox",
              license: "License / service",
              giftcard: "Gift card",
            },
            slotKinds: {
              none: "No slots (account, code or top-up)",
              noneHint: "The whole unit is sold; there is no profile grid.",
              pin_profile: "Profile with PIN",
              pin_profileHint: "Named slots with optional PIN, like Netflix or Max.",
              email_member: "Email member",
              email_memberHint: "The slot is invited to the client email. No PIN.",
              device: "Device",
              deviceHint: "Each slot is a device (CapCut, IPTV).",
              site_login: "Website (URL + username + password)",
              site_loginHint: "Parent hosting: each slot is the customer site with its URL, username and password.",
            },
            logoType: "The logo must be JPG, PNG or WebP.",
            logoSize: "The logo cannot exceed 2 MB.",
            remove: "Delete",
            createVariant: "Create plan variant",
            variantOf: "Variant of",
            variantHint: "Group plans (Standard, Family, 1 device) under the same product.",
            warrantyHint: "Warranty days shown in the customer message. Leave empty if none.",
            priceHint: "Public price (what you charge). Stored in the primary currency and also shown in FX using the exchange rate.",
            lotHint: "Typical supplier purchase size (e.g. lot of 10 mailboxes).",
            durationPlans: {
              generate: "Create 1 month / 3 months / 1 year plans",
              hint: "Save the product, then generate the duration variants.",
              saveFirst: "Save the product before generating duration plans.",
              month: "1 month",
              quarter: "3 months",
              year: "1 year",
              exists: "This product already has 1 month, 3 months and 1 year variants.",
              created: "Created {n} duration plan(s).",
            },
            codes: {
              title: "Code stock (one per line)",
              hint: "Paste PIN, VPN or license codes. One is taken per sale.",
              generatedHint: "These codes are created when associating on the platform. Track how many remain on each account; they are not preloaded here.",
              stock: "{n} code(s) available. Anything you paste now is added to stock.",
              stockLabel: "Available codes",
              empty: "No codes in stock. Paste one here or load them on the product.",
              needStock: "There are no codes in stock for this product.",
            },
          },
          catalog: {
            slots: {
              profile: { one: "Profile", plural: "Profiles", max: "Maximum profiles" },
              member: { one: "Member", plural: "Members", max: "Maximum members" },
              device: { one: "Device", plural: "Devices", max: "Maximum devices" },
              site: { one: "Site", plural: "Sites", max: "Maximum sites" },
              unit: { one: "Unit", plural: "Units", max: "Units" },
            },
            offerTypes: {
              profile: "Profile",
              full: "Full account",
              domain: "Domain",
              device: "Device",
              mailbox: "Mailbox",
              code: "Code",
              recharge: "Top-up",
            },
          },
          combos: {
            title: "Combos",
            subtitle: "Bundles at a special price, with valid accounts.",
            emptyTitle: "No combos yet",
            empty: "Create a pack of 2 to 6 products. If it has a duration, it is removed automatically when it expires.",
            noDescription: "No description",
            included: "Included products",
            rangeHint: "Select between 2 and 6 products with valid accounts.",
            maxProducts: "A combo can include at most 6 products.",
            noEligible: "No products have accounts valid for more than 3 days for this type.",
            viableAccounts: "valid accounts",
            permanent: "Permanent",
            permanentHint: "This combo does not expire.",
            until: "Until",
            validity: "Validity",
            typeProfileHint: "Only products with profile-sale accounts valid more than 3 days.",
            typeFullHint: "Only products with full-account sales valid more than 3 days.",
            priceHint: "Package price for the customer. Type it in primary currency or FX.",
          },
          suppliers: {
            title: "Suppliers",
            subtitle: "Who you buy accounts from. Phone, Telegram and notes.",
            emptyTitle: "No suppliers",
            empty: "Add a supplier if you buy accounts from third parties. You can skip this step.",
            search: "Search supplier…",
            phoneHint: "Country code and number, no + or spaces. Example: 573001234567",
            openAccounts: "View accounts",
            linkedAccounts: "Linked accounts",
            noAccounts: "No linked accounts",
            noAccountsHint: "Accounts assigned to this supplier will show up here.",
          },
          codes: {
            lookup: "Look up code",
            lookupTitle: "Lookup result",
            copied: "Code copied",
            copiedLink: "Link copied",
            found: "Code found",
            linkFound: "Link found",
            bothFound: "Code and link found",
            newSearch: "New search",
            share: "Share",
            preview: "Email",
            empty: "No recent code for this mailbox.",
            noSubject: "No subject",
            imapHint: "Connect up to 4 mailboxes that receive the codes (IMAP). Gmail uses an app password on port 993.",
            yopTitle: "Yopmail servers",
            yopHint: "For accounts whose emails arrive at Yopmail: just type the inbox address. It is checked with an automated browser using the same subjects and time window as IMAP. If the account email is already @yopmail.com, that inbox is checked directly even if not added here.",
            yopEmail: "Yopmail address (inbox)",
            yopRequired: "Type the Yopmail address",
            yopOk: "Yopmail inbox opened successfully",
            imapOk: "IMAP connection succeeded",
            mailbox: "Mailbox",
            server: "Server",
            lastOk: "Last connection succeeded",
            user: "IMAP user",
            userPlaceholder: "email@gmail.com",
            userRequired: "IMAP user is required.",
            password: "Password",
            passwordApp: "Password / App Password",
            passwordKeep: "New password (leave blank to keep)",
            passwordConfigured: "Saved",
            passwordHint: "Password saved. You can test the connection or replace it.",
            passwordHintNew: "Use a Gmail app password, not the account password.",
            passwordRequired: "Enter the app password to test this mailbox.",
            host: "IMAP host",
            port: "Port",
            portHint: "Port (993)",
            secure: "SSL/TLS",
            test: "Test connection",
            testing: "Testing…",
            testHint: "Test host, port, user and password before saving changes.",
            messagesCount: "{n} messages in the inbox",
            removeMailbox: "Delete mailbox",
            operatorTitle: "Test lookup",
            operatorHint: "Only unread mail from the last 20 minutes. An old code or link is no longer valid.",
            email: "Account email",
            filters: "Lookup filters",
            filtersHint: "Subject strings that must appear in the email. Turn it on to use it in the lookup.",
            subject: "Subject / condition",
            active: "Active",
            useInSearch: "Use",
            addFilter: "Add subject",
            removeFilter: "Remove subject",
            landingUrl: "Lookup link",
            landingHint: "Created as soon as codes are enabled. The customer opens this page and only sees their mailboxes.",
            generating: "Creating link…",
            optionalPortal: "External portal user and password (optional)",
            externalPortal: "External portal",
            externalPortalHint: "Only if you use another page.",
            serviceSubjects: "Lookup subjects",
            serviceSubjectsHint: "Only these subjects are searched in this service account mailbox.",
            noProductSubjects: "This product has no subjects. Configure them in Products.",
          },
          binance: {
            hint: "Connect Binance Pay with a read-only API key. Unpaid sales with a Binance method get an exact USDT amount and are marked paid when the transfer arrives.",
            enabled: "Enable automatic Binance Pay collection",
            apiKey: "API Key",
            apiSecret: "API Secret",
            apiKeyHint: "Binance → API Management: Enable Reading only. No withdrawals or trading.",
            apiSecretHint: "Stored encrypted. Leave blank to keep the current secret.",
            keySet: "Already set — paste a new one only to replace it",
            payId: "Pay ID / Binance ID",
            payIdHint: "The ID customers use in Binance Pay to send you USDT.",
            qrUrl: "QR URL",
            uploadQr: "Upload QR",
            qrUploaded: "QR uploaded",
            test: "Test connection",
            testOk: "API Key valid (read-only)",
            validatedAt: "Last validated: {date}",
            checkoutTitle: "Binance Pay checkout",
            exactAmount: "Pay exactly this USDT amount",
            amount: "USDT amount",
            copy: "Copy",
            copied: "Copied",
            copyFail: "Could not copy",
            checkoutHint: "The system checks Binance every minute. You can also paste the Order ID if the customer already paid.",
            expires: "Expires {date}.",
            orderId: "Order ID / Transaction ID",
            orderIdHint: "Optional: if auto-detect misses it, paste the Binance payment ID.",
            confirmOrder: "Confirm Order ID",
            refresh: "Refresh",
            paid: "Payment confirmed",
            openCheckout: "Binance checkout",
            validateTitle: "Validate Binance payment",
            validateHint: "Paste the Order ID the customer sent you to confirm the payment.",
            validateOrderHint: "Order ID or Transaction ID from Binance Pay.",
          },
          payments: {
            title: "Payment methods",
            subtitle: "Nequi, transfer or another method. Enable or disable each one.",
            emptyTitle: "No payment methods",
            empty: "Nequi, transfer, USDT or another way you get paid.",
          },
          settings: {
            subtitle: "Users, currency, payments, messages, reminders and business terms.",
            tabs: {
              users: "Users",
              plans: "Plans",
              currency: "Currency",
              payments: "Payments",
              messages: "Messages",
              reminders: "Reminders",
              terms: "Service terms",
              raffle: "Monthly raffle",
              points: "Points",
              loyalty: "Loyalty",
              codes: "Codes",
              bot: "Bot WA / Telegram",
              migrate: "Migrate AppSheet",
              binance: "Binance Pay",
            },
            paymentsUnifiedHint: "Currency, rate, profit and payment methods.",
            messagesUnifiedHint: "Delivery/renewal templates and automatic expiry reminders.",
            loyaltyHint: "Purchase points and monthly raffle to retain customers.",
            paymentMethodsTitle: "Payment methods",
            codesHint: "Up to 4 IMAP mailboxes and a test lookup. Subject filters are set on each product.",
            botHint: "Enable the shop bot on WhatsApp and/or Telegram separately. For Telegram use a @BotFather token for native buttons.",
            migrateHint: "Import the AppSheet / StreamDigi Excel (Base.xlsx) into this business: products, accounts, profiles, customers, sales, subscriptions and points.",
            migrateSheets: "Sheets read: Productos, Proveedores, M_Pago, Cuentas, Perfiles, Cliente, Ventas, Base, Control_Ingresos, Puntos.",
            migratePickFile: "Choose Excel (.xlsx)",
            migrateChangeFile: "Change file",
            migrateReplace: "Replace current business data",
            migrateReplaceHint: "When on, deletes products, accounts, sales and subscriptions for this company before loading. Settings (bot, IMAP, reminders) are kept.",
            migratePreview: "Preview",
            migrateRun: "Migrate now",
            migratePreviewTitle: "File preview",
            migrateResultTitle: "Migration result",
            migrateMissingSheets: "Required sheets are missing from the Excel file.",
            migratePreviewOk: "Valid file. Review the counts and run the migration.",
            migrateReady: "Ready to migrate",
            migrateMissing: "Missing",
            migrateDone: "Migration completed",
            migrateStarted: "Migration started on the server. It may take a few minutes; do not run it again.",
            migrateFailed: "Migration failed",
            migrateConfirmTitle: "Migrate AppSheet database?",
            migrateConfirmReplace: "Current business data will be replaced with the Excel. This cannot be undone.",
            migrateConfirmKeep: "Excel data will be added on top of existing records. May create duplicates if you already migrated.",
            botEnabled: "Bot enabled",
            botWhatsappEnabled: "Bot enabled on WhatsApp",
            botTelegramEnabled: "Bot enabled on Telegram",
            botPromoEnabled: "Show PROMO shortcut in the menu",
            botAdminNumber: "Admin WhatsApp (alerts)",
            botAdminNumberHint: "Receives new orders, payments to validate and support escalations.",
            botAdminTelegram: "Admin Telegram username",
            botAdminTelegramHint: "Without @. Example: myuser. Needs an active Telegram connection.",
            botSalesQueue: "Sales department",
            botSupportQueue: "Support department",
            botQueueNone: "No department",
            botQueueHint: "From Settings → Departments. On escalate, the ticket lands in that department (pending).",
            botQueueEmpty: "No departments yet. Create them in Settings → Departments.",
            botWelcome: "Welcome message",
            botWelcomeHint: "Use bold/italic, variables and an image. Preview on the right. Empty = automatic greeting.",
            botWelcomePlaceholder: "E.g. Hi {{nombre_cliente}}! 👋 Welcome to StreamDigi…",
            varCustomerName: "Full name",
            varFirstName: "First name",
            binanceHint: "Read-only API key, Pay ID and QR to collect USDT automatically.",
            usersHint: "WhatsApp used by each user to send business messages.",
            plansHint: "Plan names shown when creating a product: Standard, Family, EDU, 1 screen…",
            planName: "Plan name",
            addPlan: "Add plan",
            resetPlans: "Restore list",
            noPlans: "No plans. Add one or restore the default list.",
            noUsers: "No users",
            noUsersHint: "Company users appear here so you can assign a connection.",
            whatsapp: "WhatsApp connection",
            currencyHint: "Primary currency, symbol, FX rate and profit percent.",
            currencyLocal: "Primary currency",
            currencyFx: "FX",
            currencySymbol: "Symbol",
            currencyLocalHint: "The currency used to store the public price. FX is calculated with the rate.",
            currencyFxHint: "The secondary currency used for the exchange rate (usually USD).",
            currencySymbolHint: "Shown next to prices. Example: $ 10,000",
            profitPercent: "Profit %",
            profitPercentHint: "Sale price per profile or full account = sale cost × (1 + this %). Example: 50 means a 50% markup over cost.",
            timezoneTitle: "Time zone",
            timezoneHint: "Periods, due dates, schedules and any business date/time use this zone — the same one in Settings. Not the server or browser time zone.",
            timezoneChange: "Change in Settings",
            exchangeRate: "Exchange rate (local per 1 foreign)",
            binanceTtlHours: "Binance checkout window (hours)",
            binanceTtlHoursHint: "How long the customer has to pay the exact USDT (6–168 h). Default 72.",
            fetchRate: "Refresh rate",
            fetchingRate: "Fetching…",
            rateUpdated: "Today's rate",
            rateCached: "Today's rate (already fetched)",
            rateDaily: "Edit the rate and save to apply it throughout the module. To fetch the current rate, click Refresh rate and then Save.",
            rateInvalid: "Enter an exchange rate greater than zero.",
            rateError: "Could not fetch the rate right now. Check your connection or type it and save.",
            example: "Conversion example",
            messagesHint: "Texts sent on sale, renewal or expiry. Unpaid Binance sales append the payment message.",
            generalMessages: "Default messages",
            productOverride: "Leave empty to use the default, or write a product-specific text.",
            saleMessage: "Purchase details (on assign)",
            renewMessage: "Renewal message",
            expireMessage: "Expiry alert",
            reminderWalletMessage: "Include available balance message",
            reminderWalletMessageHint: "Sends an additional message when the balance covers renewal of at least one service.",
            pointsMessage: "Points balance",
            updateMessage: "Updated service details",
            payMessage: "Payment instructions (Binance / unpaid)",
            pointsMessagePlaceholder: "Message with the customer's current wallet balance.",
            pointsMessageHint: "Sent when you tap the customer's points total (Customers, cart and customer card). Also used in reminders with points.",
            pointsEarnedEnabled: "Send balance-earned (cashback) message when an order is delivered",
            pointsEarnedMessage: "Balance earned per purchase",
            pointsEarnedMessagePlaceholder: "Cashback credited and available balance. Variables: {{saldo_ganado}} {{saldo}} {{servicios_compra}}.",
            pointsEarnedHint: "Sent as a separate message right after the account data, only if the purchase was paid and earned cashback. Use {{saldo_ganado}} and {{saldo}}.",
            updateMessagePlaceholder: "Sent only after editing a service (not after a renewal).",
            saleMessagePlaceholder: "Account details the customer receives after buying.",
            renewMessagePlaceholder: "Text sent when the service is renewed.",
            payMessagePlaceholder:
              "Appended when sending sale/renew if the sale is unpaid via Binance. Vars: {{usdt}} {{pay_id}} {{vence_pago}}.",
            expireMessagePlaceholder: "Notice before or on expiry.",
            messagePlaceholder: "Tap a variable and write the text. Values are replaced when sending.",
            saveTemplates: "Save templates",
            preview: "Preview",
            previewEmpty: "Write a message to see the preview.",
            attached: "Attached file",
            removeMedia: "Remove",
            newReminder: "New reminder",
            remindersHint: "Notices days before, on the day, or after expiry, at the configured time.",
            noReminders: "No reminders",
            noRemindersHint: "Create one with days before, the same day (0) or days after expiry (negative).",
            when: "When",
            daysOffset: "Days from expiry",
            reminderType: "Reminder type",
            reminderExpiration: "Service expiration",
            reminderPayment: "Unpaid service",
            reminderExpirationHint: "Based on the service expiration date.",
            reminderPaymentHint: "Only services linked to an unpaid sale. Stops when payment is recorded.",
            paymentDays: "Days since the unpaid sale",
            paymentDaysHint: "0 = from the sale date. 3 = from the third unpaid day. Independent of service expiration.",
            paymentDaysSummary: "From {{n}} unpaid day(s)",
            paymentFrequencyOnce: "Once per unpaid sale",
            paymentFrequencyHint: "Daily: repeats while unpaid. Once: sends one reminder per unpaid sale.",
            daysOffsetHint: "3 = three days before. 0 = the same day. -3 = three days overdue.",
            daysBefore: "{{n}} days before",
            daysAfter: "{{n}} days overdue",
            daysSame: "On expiry day",
            frequency: "Frequency",
            frequencyDaily: "Every day",
            frequencyOnce: "Once",
            frequencyHint: "Daily: sent every day the rule matches. Once: only the first matching day.",
            sendHour: "Send time",
            sendHourHint: "If several reminders share the same time, they send in this list’s order.",
            notifyNumber: "Notification WhatsApp",
            notifyHint: "Number that gets a notice when this reminder sends messages.",

            reminderIncludePoints: "Include points-to-renew message",
            reminderIncludePointsHint: "Sent only if the client has enough points to redeem at least one service in the notice. The message lists which services they can cover (and if they can cover all).",
            reminderExtraMessage: "Additional message",
            reminderExtraMessageHint: "Optional. Sent after the main reminder, with the same variables ({{nombre}}, {{servicios}}, …).",
            reminderMessage: "Message",
            termsHint: "Validity, allowed use, support and refunds. No account data.",
            raffleHint: "Tickets per purchase or renewal, draw on day 1, 30-day prize and winner messages.",
            pointsHint: "Balance cashback: a % of every paid purchase or renewal is credited to the customer's wallet. Points are no longer used; the balance pays for purchases and renewals.",
            pointsSystemEnabled: "Enable balance cashback",
            pointsEquivalence: "Equivalence when granting (sale value ÷ this number)",
            pointsEquivalenceExample: "Example: {amount} ÷ {eq} = {points} points",
            cashbackPercent: "Cashback %",
            cashbackExample: "Example: a {amount} sale credits {back} to the wallet.",
            cashbackAbroad: "customers abroad:",
            pointsTermsTitle: "Balance / cashback terms",
            raffleEnabled: "Enable raffle",
            raffleDay: "Raffle day",
            raffleDayHint: "Day 1 draws purchases and renewals from the previous month. Tickets are stored only while the raffle is on.",
            raffleLastDay: "Last day of the month",
            raffleWinnerMessage: "Winner message",
            raffleWinnerPlaceholder: "Congrats {{nombre_cliente}}. You won the {{mes}} raffle with {{tickets_ganador}} tickets. Redeem 30 days before {{premio_vence}}.",
            raffleAnnounceMessage: "Announcement to customers with active services",
            raffleAnnouncePlaceholder: "The {{mes}} raffle winner is {{nombre_ganador}}. Each purchase adds a ticket.",
            raffleReportNumber: "Report WhatsApp",
            raffleReportNumberHint: "Number that receives the raffle report (winner, tickets, sent).",
            termsPlaceholder: "Write the terms: validity, allowed use, support and refunds.",
            rafflePlaceholder: "Write raffle rules: date, prize, eligible customers and how the winner is announced.",
            pointsPlaceholder: "Explain how balance (cashback) is earned, how it pays for purchases and how long it lasts. The AI Agent uses this text.",
            cashbackTemplate: "Use cashback template",
          },
        },
        setup: {
          products: { title: "Products", desc: "Define what you sell and at what price.", cta: "Create product" },
          payments: { title: "Payment methods", desc: "Tell customers how they can pay you.", cta: "Add method" },
          accounts: { title: "Inventory", desc: "Load emails, passwords and profiles ready to assign.", cta: "Add account" },
          sales: { title: "First sale", desc: "Pick a contact, a product and a free profile.", cta: "Record sale" },
        },
        tabs: {
          dashboard: "Dashboard",
          subscriptions: "Subscriptions",
          sales: "Sales",
          accounts: "Accounts",
          products: "Products",
          suppliers: "Suppliers",
          payments: "Payment methods",
        },
        new: {
          products: "New product",
          product: "New product",
          suppliers: "New supplier",
          supplier: "New supplier",
          payments: "New method",
          payment: "New payment method",
          accounts: "New account",
          account: "New account",
          sales: "New sale",
          sale: "Add service",
          customer: "New customer",
          combo: "New combo",
        },
        kpi: {
          activeSubs: "Active services",
          expiringSubs: "Due in 3 days",
          expiredSubs: "Expired",
          availableProfiles: "Free profiles",
          accounts: "Inventory accounts",
          products: "Products",
          pendingSales: "Unpaid sales",
          monthTotal: "Sales this month",
          monthProfit: "Profit this month",
          yearProfit: "Profit this year",
          weekProfit: "This week",
          historicalProfit: "All-time total",
          monthIncome: "Income",
          monthCost: "Costs",
        },
        cols: {
          contact: "Customer",
          product: "Product",
          account: "Account",
          profile: "Profile",
          endDate: "Expires",
          price: "Price",
          status: "Status",
          total: "Total",
          payment: "Payment",
          date: "Date",
          email: "Email",
          supplier: "Supplier",
          slots: "Slots",
          name: "Name",
          days: "Days",
          phone: "Phone",
          type: "Type",
          code: "Code",
          telegram: "Telegram",
          points: "Points",
          maxProfiles: "Max profiles",
          accounts: "Accounts",
          availableAccounts: "Available",
          records: "Records",
          activeAccounts: "Active",
          password: "Password",
          profiles: "Profiles",
          billing: "Billing",
          remaining: "Remaining",
          service: "Service / combo",
          accountNumber: "Account number",
          plan: "Plan",
          country: "Country",
          warranty: "Warranty",
          lot: "Lot",
        },
        fields: {
          name: "Name",
          description: "Description",
          days: "Duration (days)",
          price: "Price",
          cost: "Cost",
          phone: "Phone",
          prefix: "Prefix",
          notes: "Notes",
          type: "Type",
          accountNumber: "Account number",
          reference: "Reference",
          product: "Product",
          supplier: "Supplier",
          email: "Account email",
          loginUser: "Username",
          loginUserHint: "IPTV/Flujo panel username (does not need to be an email).",
          panelUrl: "Panel URL (optional)",
          panelUrlHint: "E.g. http://server:port — sent to the customer in the delivery message.",
          hostingAccount: "Parent account (label)",
          hostingAccountHint: "Name or code of the parent hosting. Customer credentials go on each slot.",
          siteUrl: "Site URL",
          siteUrlHint: "Customer website (e.g. https://client.yourdomain.com).",
          siteUser: "Username",
          siteUserHint: "Login for the customer website.",
          sitePassword: "Password",
          pin: "PIN",
          password: "Password",
          passwordKeep: "Leave empty to keep the current password",
          slots: "Number of profiles",
          startDate: "Start",
          none: "— None —",
          contact: "Contact *",
          contactHint: "Type at least 2 characters to search contacts.",
          profile: "Profile to assign",
          assignLater: "Assign later",
          payment: "Payment method",
          accountType: "Account type",
          identityNumber: "ID number",
          comment: "Comment",
          customerType: "Customer type",
          telegram: "Telegram username",
          pointsEnabled: "Award points on purchases",
          maxProfiles: "Maximum profiles",
          logo: "Logo (JPG, PNG or WebP, max 2 MB)",
          logoHint: "Resized to 200×200 px. Click to upload.",
          serviceUrl: "Service URL (optional)",
          isActive: "Product is active",
          accountStatus: "Account status",
          saleType: "Account type",
          pinLength: "PIN characters",
          pinCustom: "Custom PIN",
          pinEnabled: "Profile PIN",
          planLabel: "Plan (Standard, Family, EDU…)",
          originCountry: "Account country",
          deviceLimit: "Device limit",
          memberEmail: "Member email",
          deliveryCode: "Delivery code or link",
          externalId: "Top-up ID",
          warrantyDays: "Warranty days",
          lotSize: "Lot units",
          parentProduct: "Variant of (parent product)",
          emailsBulk: "Mailbox lot (one per line)",
          mailboxEmail: "Mailbox to deliver",
          customProfileName: "Custom profile name",
          profileNamePrefix: "Profile name prefix",
          endDate: "End date",
          profilePrice: "Sale cost per profile",
          comboPrice: "Combo price",
          isPermanent: "Permanent combo (does not expire)",
          durationDays: "Duration in days",
          ip: "IP",
        },
        status: {
          active: "Active",
          pending: "Pending",
          pending_payment: "Unpaid",
          paid: "Paid",
          expired: "Expired",
          cancelled: "Cancelled",
          fault: "Fault",
          idle: "Idle",
          available: "Available",
          assigned: "Assigned",
          disabled: "Inactive",
          expiring: "Expiring",
          soon: "In 3 days",
          today: "Today",
          none: "No services",
          sold: "Sold",
        },
      },
      toDoList: {
        title: "Operator tasks",
        loading: "Loading tasks...",
        searchPlaceholder: "Search tasks…",
        stats: {
          total: "Total",
          pending: "Pending",
          completed: "Done",
          urgent: "Urgent",
        },
        form: {
          newTask: "New task",
          editTask: "Edit task",
          descriptionLabel: "Task description",
          descriptionPlaceholder: "E.g. Review server settings…",
          priority: "Priority",
          category: "Category",
          add: "Add task",
          save: "Save changes",
          cancel: "Cancel",
        },
        priority: { low: "Low", medium: "Medium", high: "High" },
        categories: {
          general: "General",
          urgent: "Urgent",
          followup: "Follow-up",
          meeting: "Meeting",
          system: "System",
          customer: "Customer",
        },
        filters: {
          title: "Filters",
          all: "All",
          allCategories: "All categories",
          allStatus: "All",
          status: "Status",
          clear: "Clear filters",
        },
        statusLabel: { pending: "Pending", completed: "Completed" },
        empty: {
          none: "No tasks yet",
          noneHint: "Create your first task with the form above",
          filtered: "No tasks match the filters",
          filteredHint: "Adjust filters to see more tasks",
        },
        details: {
          title: "Task details",
          content: "Content",
          priority: "Priority",
          category: "Category",
          status: "Status",
          id: "ID",
          createdAt: "Created",
          updatedAt: "Last update",
          notAvailable: "Not available",
          close: "Close",
        },
        tooltips: {
          markPending: "Mark as pending",
          markDone: "Mark as completed",
          edit: "Edit task",
          delete: "Delete task",
        },
      },
      helps: {
        title: "Help center",
        form: {
          title: "Title",
          videoCode: "Video URL (YouTube)",
          description: "Description",
        },
        table: {
          title: "Title",
          description: "Description",
          video: "Video",
          preview: "Preview",
          content: "Content",
          source: "Source",
          visibility: "Visibility",
          actions: "Actions",
        },
        library: {
          title: "Video library",
          noDescription: "No description",
        },
        summary: {
          total: "Total",
          visible: "Visible",
          hidden: "Hidden",
          types: "YT/Ext",
        },
        videoTypes: {
          youtube: "YouTube",
          external: "External",
          unknown: "Video",
        },
        buttons: { clear: "Clear", delete: "Delete", save: "Save", saving: "Saving..." },
        formTitle: {
          edit: "Edit help video",
          create: "Create new help video",
        },
        sectionVideo: "Help video information",
        placeholders: {
          video: "https://youtu.be/6FdRJTw46qI or https://yourdomain.com/video.mp4",
          thumbnail: "https://yourdomain.com/thumbnails/video.jpg",
        },
        helpers: {
          youtubeDetected: "✅ YouTube video detected",
          externalDetected: "✅ External video detected",
          pasteHint:
            "Paste a YouTube URL or an external video URL (e.g. https://yourdomain.com/video.mp4)",
        },
        thumbnail: {
          label: "Thumbnail URL (optional)",
          hint: "Optional custom thumbnail image URL. If empty, YouTube thumbnail or a placeholder is used.",
        },
        grid: {
          emptyTitle: "No help videos registered",
          emptySubtitle: "Create your first help video to get started",
        },
        tooltips: {
          editRow: "Edit help video",
          hide: "Hide this video from companies",
          show: "Show this video to companies",
          moveUp: "Move video up",
          moveDown: "Move video down",
        },
        visibility: {
          visible: "Visible",
          hidden: "Hidden",
        },
        validation: {
          invalidVideoInput:
            "Invalid video URL. Enter a YouTube URL or a valid external URL (e.g. https://yourdomain.com/video.mp4)",
          processFailed: "Could not process the video URL",
          urlInvalid: "Invalid URL. It must start with http:// or https://",
          urlExtensionHint:
            "The URL has no video file extension. Ensure the server returns the correct Content-Type.",
        },
        toast: {
          youtubeDetected: "YouTube video detected: {{code}}",
          externalDetected: "External video detected and saved",
        },
        messages: {
          loadError: "Could not load help items",
          saveSuccess: "Saved successfully.",
          saveError: "Could not save. Check for duplicate name or incomplete fields.",
          deleteSuccess: "Deleted successfully.",
          deleteError: "Could not delete",
          hideSuccess: "Video hidden from companies",
          showSuccess: "Video visible to companies",
          visibilityError: "Could not update video visibility",
          orderSuccess: "Video order updated",
          orderError: "Could not update video order",
          deleteTitle: "Delete item",
          deleteMessage: "Delete this help item?",
          videoUnavailable: "Video not available",
          videoLoadError: "Could not load video",
          videoLoadHint: "The video may be unavailable or blocked on this domain.",
          videoCorsHint: "Ensure the server allows public access (CORS) and the URL is correct.",
          youtubeError: "Could not load YouTube video",
          videoUrlError: "Could not load video. Check the URL and format.",
          videoNotSupported: "Your browser does not support video.",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "Delete this tag?",
          deleteMessage: "This cannot be undone.",
          deleteAllMessage: "Delete all tags?",
          deleteAllTitle: "Delete all",
        },
        table: {
          name: "Name",
          tagName: "Tag name",
          color: "Color",
          tickets: "Tagged tickets",
          taggedTickets: "Tagged tickets",
          kanban: "Kanban",
          origin: "Origin",
          actions: "Actions",
        },
        kanbanActive: "ACTIVE",
        kanbanInactive: "OFF",
        originProfile: "By profile",
        originManual: "Manual",
        readOnly: "Read-only",
        profileTagTitle: "Kanban column from Calendar setup. Read-only.",
        manualTagTitle: "Manually created tag",
        readOnlyHint:
          "Profile columns cannot be edited here. Change profile in Calendar > Settings.",
        tooltips: { editTag: "Edit tag", deleteTag: "Delete tag" },
        buttons: { add: "New tag", deleteAll: "Delete all" },
        toasts: {
          deletedAll: "All tags deleted.",
          deleted: "Tag deleted.",
        },
      },
      files: {
        title: "File lists",
        adminTitle: "File manager",
        searchPlaceholder: "Search file lists…",
        newList: "New file list",
        listCount: "{{count}} lists",
        table: {
          name: "List name",
          description: "Description",
          fileCount: "Files",
          createdAt: "Created",
          actions: "Actions",
        },
        noDescription: "No description",
        filesInList: "{{count}} files",
        tooltips: { editList: "Edit list", deleteList: "Delete list" },
        contacts: "Contacts",
        actions: "Action",
        toasts: {
          deleted: "List deleted.",
          deletedAll: "All lists deleted.",
        },
        buttons: { add: "Add", deleteAll: "Delete all" },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete all",
          deleteMessage: "Delete this list?",
          deleteAllMessage: "Delete all lists?",
        },
      },
      fileModal: {
        title: { add: "New file list", edit: "Edit file list" },
        buttons: {
          okAdd: "Save",
          okEdit: "Update",
          cancel: "Cancel",
          fileOptions: "Add file",
        },
        form: {
          name: "List name",
          message: "List details",
          fileOptions: "Files",
          extraName: "Caption sent with file",
          extraValue: "Option value",
        },
        dragDrop: {
          sectionTitle: "Files",
          main: "Drag and drop files here",
          sub: "or click to select files",
          formats: "Supported: PDF, DOC, DOCX, XLS, XLSX, CSV, JPG, PNG, MP4, MP3",
        },
        table: {
          thumbnail: "Thumb",
          name: "Name",
          format: "Format",
          size: "Size",
          type: "Type",
          actions: "Actions",
        },
        validation: { nameMin: "Name too short", required: "Required" },
        fileSize: { bytes: "Bytes", kb: "KB", mb: "MB", gb: "GB" },
        tooltips: { removeFile: "Remove file" },
        success: "File list saved.",
      },
      financial: {
        title: "Billing",
        pageTitle: "Billing and subscriptions",
        tabs: {
          subscriptions: "Subscriptions",
          invoices: "Invoices",
          management: "Management",
        },
        table: {
          id: "ID",
          details: "Details",
          value: "Amount",
          dueDate: "Due date",
          status: "Status",
          action: "Action",
        },
        status: {
          paid: "Paid",
          overdue: "Overdue",
          open: "Open",
        },
        buttons: {
          pay: "PAY",
          paid: "PAID",
        },
        messages: {
          noInvoices: "No invoices to display",
          paymentSuccess: "Payment processed successfully",
          paymentError: "Could not process payment",
        },
        subscription: {
          currentPlanLabel: "Current plan",
          noPlanAssigned: "No plan assigned",
          availablePlans: "Available plans",
          availablePlansHint:
            "Choose a plan to subscribe. You will see the available payment methods (Binance Pay, PayPal, Stripe or manual payment).",
          perMonth: "/mo",
          users_one: "{{count}} user",
          users_other: "{{count}} users",
          connections_one: "{{count}} WhatsApp connection",
          connections_other: "{{count}} WhatsApp connections",
          queues_one: "{{count}} queue",
          queues_other: "{{count}} queues",
          featureCampaigns: "Campaigns",
          featureSchedules: "Scheduling",
          featureOpenAi: "Artificial intelligence",
          subscribe: "Subscribe",
          processing: "Processing…",
          noPlansTitle: "No plans available",
          noPlansHint: "Contact your administrator for more information",
          manualPaymentTitle: "Manual payment available",
          manualPaymentHint:
            "You can choose a plan and contact the administrator to coordinate payment.",
          manualPaymentEmail: "Email",
          binanceTitle: "Binance Pay checkout",
          binanceExact: "Pay exactly this USDT amount",
          binanceHint: "The system checks the payment every minute. You can also paste the Order ID.",
          binanceOrderId: "Order ID / Transaction ID",
          binanceOrderHint: "Optional if auto-detect misses it.",
          binanceConfirm: "Confirm Order ID",
          binanceRefresh: "Refresh",
          binancePaid: "Payment confirmed",
          binanceCopy: "Copy",
          binanceCopied: "Copied",
          binanceCopyFail: "Could not copy",
          binanceStepsTitle: "How to pay",
          binanceStep1: "Open the Binance app and go to Pay → Send.",
          binanceStep2: "Send exactly {{amount}} USDT to Pay ID {{payId}}.",
          binanceStep3: "Don't round it: the cents identify your payment.",
          binanceStep4: "Done: we detect it automatically. If it takes long, paste the Binance Order ID here.",
          binanceWhatsappAlt: "Prefer WhatsApp? Send PAGAR PLAN to",
          manualDefault: "Contact the administrator to arrange the manual payment of your plan.",
          manualConfigHint: "Set up email, WhatsApp or instructions in Settings > Subscriptions.",
          manualTitle: "Manual payment",
          pageTitle: "Subscription",
          trialLabel: "Trial period",
          trialEnds: "Your trial period ends in {{days}} days!",
          billingEmail: "Billing email",
          subscribeNow: "Subscribe now!",
          selectedPlan: "Selected plan",
          value: "Amount",
          close: "Close",
        },
        checkout: {
          title: "Almost there!",
          steps: { data: "Details", customize: "Customize", review: "Review" },
          back: "BACK",
          next: "NEXT",
          pay: "PAY",
          success: "Subscription created! Waiting for payment confirmation.",
          notFound: "Not found",
          users: "{{count}} users",
          connections: "{{count}} connections",
          queues: "{{count}} queues",
          select: "SELECT",
          perMonth: "/mo",
          summary: "Subscription summary",
          planDetails: "Plan details",
          usersLabel: "Users",
          billing: "Billing: Monthly",
          paymentInfo: "Payment information",
          name: "Name",
          address: "Address",
          copied: "Copied",
          copyQr: "Copy QR code",
          pixHint: "To finish, pay by scanning or pasting the code above.",
          renewed: "Your license was renewed until {{date}}!",
          addressIntro: "We need some information",
          fullName: "Full name*",
          fullNameRequired: "Full name is required",
          street: "Address*",
          streetRequired: "Address is required",
          city: "City*",
          cityRequired: "City is required",
          state: "State*",
          stateRequired: "State is required",
          zip: "ZIP code*",
          zipRequired: "ZIP code is required",
          zipInvalid: "Invalid ZIP code",
          country: "Country*",
          countryRequired: "Country is required",
          countries: { BR: "Brazil", CO: "Colombia", US: "United States" },
        },
      },
      kanban: {
        open: "Open",
        tagNotFound: "Tag not found.",
        cannotMapStatus: "Cannot map column to appointment status.",
        appointmentUpdated: "Appointment updated.",
        ticketMoved: "Ticket moved.",
        moveError: "Could not move card.",
        configureAgendaHint: "The board uses Kanban tags. Enable Calendar in Settings for profile columns.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
        buttons: {
          new: "New",
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
        confirmation: {
          title: "⚠️ Confirm ticket closure",
          subtitle: "This will permanently close ALL open tickets",
          warning: "This action cannot be undone",
          whichTicketsQuestion: "Which tickets do you want to close?",
          noTicketsForOption: "No tickets to close for the selected option",
          warningEmojiAria: "Warning",
          optionAttendingOpen: "IN PROGRESS (Open)",
          optionPending: "PENDING",
          optionBoth: "BOTH (IN PROGRESS + PENDING)",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
          searchMessagesTooltip: "Also search message content (slower)",
        },
        buttons: {
          showAll: "All",
        },
        managerTabs: {
          tooltips: {
            newTicket: "Create new ticket",
            resolveTickets: "Resolve tickets",
            showOpen: "Show open tickets",
            showClosed: "Show closed tickets",
            filterByQueues: "Filter by queues",
            filterByTags: "Filter by tags",
            activeFilters: "View active filters",
          },
          emptyQueues: "No queues available",
          emptyTags: "No tags available",
          tabs: {
            groups: "GROUPS",
            aiAgents: "AI AGENTS",
          },
        },
        filterPanel: {
          title: "Filters",
          show: "Show",
          hide: "Hide",
          departments: "Queues",
          tags: "Tags",
          departmentsWithCount: "Queues ({{count}})",
          tagsWithCount: "Tags ({{count}})",
          clearFilters: "Clear filters",
          emptyState: "No active filters. Select queues or tags above.",
        },
        welcome: {
          title: "Welcome to your chat workspace",
          subtitle: "You can open a new chat or wait until one is assigned to you",
        },
        aria: {
          resizeTicketsPanel: "Resize tickets panel",
        },
        mobile: {
          bottomNav: {
            chat: "Chat",
            tickets: "Tickets",
          },
        },
        searchResults: {
          searchAria: "Search",
          searching: "Searching...",
          resultsFor: 'Results for "{{term}}"',
          noResults: "No results found",
          emptySection: "No results in this section.",
          total: "{{count}} total",
          sections: {
            open: "IN PROGRESS",
            pending: "PENDING",
            closed: "CLOSED",
          },
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        allHeader: "All",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        selectQueue: "Select a department",
        selectConnection: "Select a connection",
        selectChannel: "Where should the conversation start?",
        channelWhatsApp: "WhatsApp",
        channelTelegram: "Telegram",
        departmentAttention: "Support department",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
        errors: {
          contactRequired: "Select a contact to create the ticket",
          connectionRequired: "Select a connection",
          queueRequired: "Select a department",
          channelRequired: "Choose WhatsApp or Telegram",
          noChannel: "This contact has neither WhatsApp nor Telegram",
          noWhatsApp: "This contact has no WhatsApp",
          noTelegram: "This contact has no Telegram",
        },
      },
      mainDrawer: {
        mobileBar: {
          label: "Main shortcuts",
          dashboard: "Home",
          chats: "Chats",
          negocio: "Business",
          groups: "Groups",
          status: "Status",
          campaigns: "Campaigns",
          contacts: "Contacts",
          settings: "Settings",
        },
        groups: {
          whatsapp: "Chats",
          dashboard: "Dashboard",
          gruposWA: "Groups & channels",
          estadosWA: "Status / Stories",
          mensajes: "Messaging",
          configuracion: "Settings",
          flowbuilder: "FlowBuilder",
          utilidades: "Utilities",
          negocio: "Business",
        },
        listItems: {
          dashboard: "Dashboard",
          metrics: "Metrics",
          connections: "Connections",
          tickets: "Tickets",
          gettingStarted: "Getting started",
          quickMessages: "Quick replies",
          kanban: "Kanban",
          todolist: "Tasks",
          contacts: "Contacts",
          groupsWA: "Group/channel list",
          newslettersWA: "Channels",
          queues: "Queues",
          tags: "Tags",
          administration: "Administration",
          users: "Users",
          userRoles: "Users",
          settings: "Settings",
          helps: "Help",
          messagesAPI: "API",
          appointments: "Calendar",
          negocio: "Business",
          negocioResumen: "Overview",
          negocioCustomers: "Customers",
          negocioServices: "Services",
          negocioSubscriptions: "Collections",
          negocioSales: "Movements",
          negocioAccounts: "Accounts",
          negocioProducts: "Products",
          negocioCombos: "Combos",
          negocioSuppliers: "Suppliers",
          negocioSettings: "Settings",
          negocioPayments: "Payment methods",
          negocioUsers: "Users",
          negocioCurrency: "Currency",
          negocioMessages: "Messages",
          negocioReminders: "Reminders",
          negocioTerms: "Service terms",
          negocioRaffle: "Monthly raffle",
          negocioPoints: "Points",
          negocioSectionOperate: "Operations",
          negocioSectionInventory: "Inventory",
          negocioSectionSetup: "Setup",
          schedules: "Scheduled messages",
          campaigns: "Campaigns",
          campaignsDispatch: "Message broadcasts",
          contactLists: "Contact lists",
          statusCampaigns: "Status / Stories",
          campaignShippingReports: "Shipping reports",
          annoucements: "Announcements",
          chats: "Internal chat",
          localChat: "Local chat",
          financeiro: "Billing",
          subscription: "Subscription",
          files: "File list",
          prompts: "AI agents",
          queueIntegration: "Integrations",
          flowbuilders: "Flow list",
          flowcampaigns: "Flow campaigns",
          dashboardWhatsApp: "Activity",
          vpsPerformance: "VPS performance",
          satisfactionSurveys: "Satisfaction surveys",
          groupCampaigns: "Group campaigns",
          groupCampaignShippingReports: "Shipping reports",
          metaHub: "Meta",
        },
        appBar: {
          notRegister: "No notifications",
          user: {
            profile: "Profile",
            logout: "Logout",
            label: "User:",
          },
          tooltips: {
            openDrawer: "Open menu",
            closeDrawer: "Close menu",
            navigationMenu: "Navigation menu",
            openNavigationMenu: "Open navigation menu",
            internalChat: "Internal chat",
            help: "Help",
            announcements: "Announcements",
            whatsappNotifications: "WhatsApp notifications",
            settings: "Settings",
            updateVersion: "Update version",
            logout: "Sign out",
          },
          settingsMenu: {
            lightMode: "Light mode",
            darkMode: "Dark mode",
            logs: "Logs",
          },
          pwa: {
            installApp: "Install app",
            enableNotifications: "Enable notifications",
            notificationsOn: "Notifications enabled",
            bannerInstallTitle: "Install WATOOLX",
            bannerInstallBody: "Get alerts for new messages even when the panel is closed.",
            bannerNotifyTitle: "Turn on notifications",
            bannerNotifyBody: "Stay up to date with new tickets and messages, including in the installed app.",
            bannerInstall: "Install",
            bannerEnable: "Enable",
            bannerLater: "Not now",
            iosTitle: "Add to Home Screen",
            iosBody: "In Safari: tap Share, then Add to Home Screen. Open the app from the icon and enable notifications.",
            gotIt: "Got it",
            permissionDenied: "Notifications are blocked. Enable them in browser or phone settings.",
          },
          versionLong: "VERSION {{version}}",
          versionShort: "V{{version}}",
        },
      },
      notifications: {
        noTickets: "No notifications.",
        whatsappDisconnected: {
          title: "No WhatsApp connections",
          body: "No active connections. Set up or reconnect your WhatsApp connections to continue.",
          reconnect: "RECONNECT NOW",
          close: "Close",
        },
      },
      whatsappConnectionsMenu: {
        loadingConnections: "Loading connections…",
        tooltipNoConnections: "No WhatsApp connections — click for details",
        tooltipSomeConnected: "At least one connection is active — click to view list",
        tooltipNoneActive: "No active connection — click to view list",
        ariaLabel: "WhatsApp connections status",
        menuTitle: "WhatsApp connections",
        loading: "Loading…",
        noneConfigured: "No connections configured",
        connectionFallback: "Connection #{{id}}",
        manage: "Manage connections…",
        status: {
          connected: "Connected",
          opening: "Connecting…",
          disconnected: "Disconnected",
        },
      },
      quickMessages: {
        title: "Quick replies",
        searchPlaceholder: "Search...",
        searchFieldPlaceholder: "Search quick replies...",
        noAttachment: "No attachment",
        noFile: "No attachment",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This cannot be undone. Continue?",
        },
        buttons: {
          add: "Add",
          addReply: "Add reply",
          attach: "Attach file",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut saved!",
          deleted: "Shortcut deleted!",
        },
        dialog: {
          title: "Quick message",
          shortcode: "Shortcut",
          message: "Reply",
          save: "Save",
          cancel: "Cancel",
          geral: "Allow editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow view",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "File name",
          status: "Status",
          shortcodeHeader: "SHORTCUT",
          messageHeader: "REPLY",
          mediaNameHeader: "FILE NAME",
          statusHeader: "STATUS",
          actionsHeader: "ACTIONS",
        },
        tooltips: {
          openAttachment: "Click to open file",
          edit: "Edit quick reply",
          delete: "Delete quick reply",
        },
      },
      messagesAPI: {
        title: "WhatsApp Messaging API",
        documentation: {
          title: "Message sending documentation",
          methods: "Sending methods",
          instructions: "Instructions",
          importantNotes: "Important notes",
          textMessages: "Text messages",
          mediaMessages: "Media messages",
          endpoint: "Endpoint",
          method: "Method",
          headers: "Headers",
          body: "Body",
          formData: "FormData",
          testSend: "Send test",
          send: "Send",
        },
        instructions: {
          tokenRequired:
            "Before sending messages, register the token linked to the connection that will send them. Go to Connections, edit the connection, and paste the token in the appropriate field.",
          numberFormat:
            "The destination number must not include masks or special characters. It must contain:",
          countryCode: "Country code",
          areaCode: "Area code",
          number: "Number",
        },
        importantInfo: {
          title: "Important information",
          tokenLabel: "Token required",
          tokenBody:
            "You must register a token linked to the connection that will send the messages",
          formatLabel: "Number format",
          formatBody: "Country code + area code + number (no special characters)",
          exampleLabel: "Example",
          exampleBody: "51959858768 (Peru: 51, area: 959, number: 858768)",
          channelsLabel: "Which connection to use",
          channelsBody: "Text, media and polls: a WhatsApp token. Groups: a WhatsApp or Telegram token. @newsletter channels: WhatsApp only. Statuses and stories: a WhatsApp or Telegram token. This does not open a chat.",
        },
        chips: {
          endpoint: "ENDPOINT",
          method: "METHOD",
          headers: "HEADERS",
          upTo100mb: "UP TO 100MB",
        },
        common: {
          apiInfoTitle: "API information",
          testSendTitle: "Send test",
          bodyJson: "Body (JSON):",
          formData: "FormData:",
        },
        section1: {
          title: "1. Text messages",
          intro: "Send plain text messages through the WhatsApp Business API.",
          bodySnippet: `{ "number": "51959858768", "body": "Your message" }`,
        },
        section2: {
          title: "2. Media messages",
          intro:
            "Send media files (images, videos, documents, audio) through the WhatsApp Business API.",
          maxCapacity: "Maximum capacity:",
          maxCapacityBody: "Files up to 100 MB",
          formDataNumber: "number:",
          formDataNumberEx: "51959858768",
          formDataMedias: "medias:",
          formDataMediasEx: "file",
          formDataBody: "body:",
          formDataBodyEx: "optional caption text",
          fileTypesTitle: "Supported file types:",
          images: "Images:",
          imagesEx: "JPG, PNG, GIF (up to 5MB)",
          videos: "Videos:",
          videosEx: "MP4, AVI, MOV (up to 16MB)",
          documents: "Documents:",
          documentsEx: "PDF, DOC, XLS, PPT (up to 100MB)",
          audio: "Audio:",
          audioEx: "MP3, WAV, OGG (up to 16MB)",
        },
        section3: {
          title: "3. Group messages",
          intro: "Send text to a group. A WhatsApp token uses the group ID. A Telegram token uses that account's group or channel ID.",
          bodySnippet: `{ "number": "12036312345678901234", "body": "Your message" }`,
          groupNote: "Note:",
          groupNoteBody: "WhatsApp appends @g.us. Telegram uses the ID as-is and does not open a private chat.",
        },
        section4: {
          title: "4. Group media",
          intro: "Send one file to a WhatsApp group or, with a Telegram token, to a Telegram group or channel.",
          formDataNumberLi: "Group ID (e.g. 12036312345678901234)",
          formDataMediasLi: "media file",
        },
        sectionChannel: {
          title: "5. WhatsApp Channels: Text, Media and Polls",
          intro:
            "Publish content to a WhatsApp Channel administered by the authenticated connection. The same endpoint accepts text, one media file or a poll.",
          destinationTitle: "Destination:",
          destinationBody:
            "newsletterJid, jid, link or channelLink. The recommended value is a JID ending in @newsletter.",
          securityTitle: "Authorization:",
          securityBody:
            "Bearer token for the administrator connection. It must be CONNECTED and have the ADMIN or OWNER role in the channel.",
          textTitle: "Publish text",
          textCurl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN" \\
  -F "newsletterJid=123456789@newsletter" \\
  -F "body=Channel post"`,
          mediaTitle: "Publish media with optional text",
          mediaCurl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN" \\
  -F "newsletterJid=123456789@newsletter" \\
  -F "body=Optional text" \\
  -F "medias=@/path/file.jpg"`,
          pollTitle: "Publish a poll",
          pollCurl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer TOKEN" \\
  -F "newsletterJid=123456789@newsletter" \\
  -F "type=poll" \\
  -F "question=Which content do you prefer?" \\
  -F 'options=["Tutorials","News","Offers"]' \\
  -F "selectableCount=1"`,
          responseNote:
            "HTTP 200 means the publication was verified. HTTP 202 means it was submitted to the socket but could not be confirmed by ACK, event or fetch. Check success, publishedVerified, verification, serverId and messageId.",
          limitsNote:
            "WhatsApp only. A Telegram channel is published with the group endpoint and a Telegram token. Only one file is processed per request. A poll cannot include media.",
        },
        sectionStatus: {
          title: "Statuses and stories",
          intro: "Publishes immediately to WhatsApp Status or a Telegram story. The token selects the connection. It does not send a chat message.",
          whatsappTitle: "WhatsApp",
          whatsappBody: "Text, photo, video or audio. targetType all publishes in batches of 50 to contacts who have a chat on that line. WhatsApp shows it to people who saved the number. targetType contacts limits the list with contactIds.",
          telegramTitle: "Telegram",
          telegramBody: "A photo or video is required. The text is the caption. One story is published for the account's contacts. Text alone returns 400.",
          fieldsTitle: "Fields",
          fieldsBody: "name (optional), targetType (all or contacts), contactIds (1,2,3 or [1,2,3]), body or message, media, medias or file.",
          curl: `curl -X POST "{{endpoint}}" \\
  -H "Authorization: Bearer CONNECTION_TOKEN" \\
  -F "targetType=all" \\
  -F "body=Status text" \\
  -F "media=@/path/image.jpg"`,
          testNote: "200: published. 400: missing content or, on Telegram, the photo or video. 401: invalid token. 409: the connection is not connected.",
        },
        sectionPoll: {
          title: "6. Contact Polls, Questions and Quizzes",
          intro:
            "Send a native WhatsApp poll to a contact. A question or quiz is represented by a single-choice or multiple-choice poll.",
          bodySnippet: `{
  "type": "poll",
  "number": "51959858768",
  "question": "Which schedule do you prefer?",
  "options": ["Morning", "Afternoon", "Evening"],
  "selectableCount": 1
}`,
          fieldsTitle: "Accepted fields:",
          typeField:
            "poll. survey, encuesta, question, pregunta, quiz and cuestionario are also accepted.",
          numberField: "contact number with country code and no symbols.",
          questionField:
            "question text. question takes precedence; body is accepted as an alias.",
          optionsField:
            "at least 2 options, as a JSON array or text separated by commas/new lines.",
          selectableCountField:
            "1 for single choice; 0 for multiple choice; an integer up to the option count is also accepted.",
          quizNote:
            "A multi-question quiz requires multiple requests, one poll per question. The API does not calculate correct answers or scores.",
          validationNote:
            "Responses: 200 when sent; 400 for invalid question/options; 401 for an invalid token; connection error when WhatsApp is offline. Do not attach media to a poll request.",
        },
        forms: {
          tokenRegistered: "Registered token",
          tokenRegisteredReq: "Registered token *",
          tokenPlaceholder: "Enter your token here",
          number: "Number",
          numberReq: "Number *",
          message: "Message",
          messageReq: "Message *",
          messageOptional: "Message (optional)",
          messageOptionalPlaceholder: "Optional caption to send with the file...",
          messagePlaceholder: "Type your message here",
          numberPlaceholder: "51980795094",
          fileName: "File name",
          sendMessage: "SEND MESSAGE",
          sendMedia: "Send media",
          selectFile: "Select file",
          clickUploadHint: "Click to select a media file",
          fileSize: "Size:",
          groupId: "Group ID *",
          groupIdHelper: "Group ID without @g.us (e.g. 12036312345678901234)",
          groupIdHelperShort: "Group ID without @g.us",
          sendToGroup: "Send to group",
          sendMediaToGroup: "Send media to group",
          pollQuestion: "Question *",
          pollOptions: "Options *",
          pollOptionsHelper: "Enter one option per line or separate them with commas. Minimum 2.",
          pollSelectionMode: "Selection mode",
          pollSingleChoice: "Single choice",
          pollMultipleChoice: "Multiple choice",
          sendPoll: "Send poll",
          whatsappId: "WhatsApp connection ID *",
          channelJid: "Channel JID or link *",
          channelMode: "Publication type",
          channelText: "Text",
          channelMedia: "Media",
          channelPoll: "Poll",
          sendChannel: "Publish to channel",
        },
        fileSize: {
          bytes: "Bytes",
          kb: "KB",
          mb: "MB",
          gb: "GB",
        },
        apiInfo: {
          textMessageInfo: "Below is the information required to send text messages:",
          mediaMessageInfo: "Below is the information required to send media messages:",
          authorization: "Authorization (Bearer token) and Content-Type (application/json)",
          multipartForm: "Authorization (Bearer token) and Content-Type (multipart/form-data)",
          exampleBody: '{ "number": "51959858768", "body": "Your message" }',
          exampleNumber: "51959858768",
          exampleFile: "file",
        },
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered token",
        },
        mediaMessage: {
          number: "Number",
          body: "File name",
          media: "File",
          token: "Registered token",
        },
        section5: {
          title: "7. External API — N8N / TypeBot",
          intro:
            "Endpoints for external integrations (N8N, TypeBot, etc.). Use the same WhatsApp token as the messaging API. Responses include a variables object compatible with TypeBot/N8N.",
          baseUrl: "Base URL:",
          headersLine: "Headers:",
          getTicketByNumber: "GET — Ticket by number",
          getTicketById: "GET — Ticket by ID",
          getUsers: "GET — Users / agents",
          getTags: "GET — Tags",
          putAssignTag: "PUT — Assign tag",
          putUpdateTicket: "PUT — Update ticket",
          bodyLabel: "Body:",
          altPostTitle: "POST alternatives (body or query for Typebot):",
          postTicketBody1:
            'POST {{base}}/ticket — Body: { "atendimento": 1223 } or { "number": "51980795334" }',
          postTicketBody2: "POST {{base}}/ticket?number={{telefono}} — URL variables (Typebot)",
          postTicketBody3:
            "POST {{base}}/ticket/tag?atendimento={{atendimento}}&tagId=6 — query params",
          postTicketBody4:
            'POST {{base}}/ticket — Body: { "atendimento": 1223, "status": "open", "userId": 1 } (update)',
          postUsersTags: "POST {{base}}/users — POST {{base}}/tags",
          variablesObjectTitle: "variables object (ticket responses):",
          variablesList:
            "atendimento, nome, numero, status, canal, grupo, user, userEmail, queue, tags, whatsappNumber, whatsappName",
          typebotGuideTitle: "Typebot guide (validated flow):",
          typebotStep1: "Input: ask for number, save in variable telefono",
          typebotStep2:
            "HTTP Request: POST /ticket?number={{telefono}} (use braces to insert variable)",
          typebotStep3: "Headers: Authorization = Bearer token",
          typebotStep4: "Save in variables: data.variables.numero, nome, atendimento",
          typebotStep5: "Text: show numero, nome, atendimento",
          seeGuide: "See guide 0275 for full detail.",
        },
        messages: {
          success: "Message sent successfully",
          successMedia: "Media message sent successfully",
          successGroup: "Message sent to the group successfully",
          successGroupMedia: "Media message sent to the group successfully",
          successPoll: "Poll sent successfully",
          pollOptionsError: "The poll requires at least 2 valid options",
          successChannel: "Content published and verified in the channel",
          channelNotVerified: "The publication was sent but could not be verified",
          groupSendError: "Could not send message to group",
          groupMediaError: "Could not send media to group",
          noPermission: "This company cannot access this page. Redirecting…",
        },
        errors: {
          backendUrlNotConfigured: "REACT_APP_BACKEND_URL is not configured",
        },
      },
      queues: {
        title: "Queues",
        toasts: {
          deleted: "Queue deleted successfully.",
        },
        table: {
          id: "ID",
          department: "Queue",
          name: "Name",
          color: "Color",
          automation: "Automation",
          greeting: "Greeting message",
          actions: "Actions",
        },
        automationLabels: {
          flowbuilder: "FLOWBUILDER",
          prompt: "PROMPT",
          integration: "INTEGRATION",
          chatbot: "CHATBOT",
          none: "No automation",
        },
        placeholders: {
          noGreeting: "No message",
        },
        tooltips: {
          editQueue: "Edit queue",
          deleteQueue: "Delete queue",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueOptions: {
        title: "Menu option chatbot",
        subtitle:
          "Define the buttons the contact will see in the chat (multi-level menu). This is not free-text AI: the user taps options. Use “Add” for each menu item.",
        add: "Add",
        placeholder: {
          title: "Option title",
          message: "Option text",
        },
        undefinedTitle: "Untitled",
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      users: {
        title: "Users",
        table: {
          id: "ID",
          status: "Status",
          name: "Name",
          email: "Email",
          profile: "Profile",
          department: "Department",
          lastConnection: "Last connection",
          lastConnectionNow: "Online now",
          connected: "Connected",
          disconnected: "Disconnected",
          actions: "Actions",
        },
        profiles: {
          admin: "Admin",
          supervisor: "Supervisor",
          user: "Agent",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        error: "Could not save settings.",
        title: "Settings",
        schedules: {
          success: "Schedules saved successfully.",
        },
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
        tabs: {
          options: "Options",
          schedules: "Schedules",
          version: "Versions",
          smtp: "SMTP",
          alerts: "Alerts",
          subscriptions: "Subscriptions",
          logo: "Web",
          companies: "Companies",
          registerCompany: "Register company",
          plans: "Plans",
          help: "Help",
          performance: "Server performance",
        },
        options: {
          userRating: "User rating",
          userRatingDesc: "Allows users to rate the service received",
          userRatingMessageText: "Rating request message",
          userRatingMessageTextDesc:
            "Sent when the ticket is closed (along with the WhatsApp connection text if any). Max. 500 characters. Same rules as the call message: cannot be empty when saving.",
          userRatingMessageTextPlaceholder: "Type 1 to 3 to rate…",
          sendGreetingAcceptedMessageText: "Greeting text on accept (menu)",
          sendGreetingAcceptedMessageTextDesc:
            "Used as the options menu greeting when the queue has no custom message. Mustache variables: {{name}}, {{firstName}}, etc.",
          sendGreetingAcceptedMessageTextPlaceholder: "Hi {{name}}! Thanks for contacting us…",
          transferTicketMessageText: "Transfer between queues message",
          transferTicketMessageTextDesc:
            "Only sent if “Send transfer message” is enabled. Variables: {{name}}, {{firstName}} and {queueName} or {{queueName}} for the target queue.",
          transferTicketMessageTextPlaceholder: "Hi {{name}}! You have been transferred…",
          greetingOneQueueMessageText: "Greeting with a single queue",
          greetingOneQueueMessageTextDesc:
            "Replaces or complements the connection greeting when only one queue exists and the option is on. Mustache: {{name}}, {{firstName}}, etc. If left blank when saving, default text is restored.",
          greetingOneQueueMessageTextPlaceholder: "Hi {{name}}! Thanks for writing us…",
          scheduleType: "Schedule type",
          ignoreGroupMessages: "Ignore group messages",
          acceptCall: "Accept calls",
          sendCallAutoMessage: "Send automatic message when calls are disabled",
          sendCallAutoMessageDesc:
            "When enabled, an automatic message is sent when calls are disabled",
          callAutoMessage: "Automatic call message",
          callAutoMessageDesc: "Customize the message sent automatically when calls are disabled",
          callAutoMessagePlaceholder: "Type the automatic message (max 500 characters)",
          restoreDefault: "Restore default",
          preview: "Preview",
          chatbotType: "Chatbot type",
          sendGreetingAccepted: "Send greeting on accept",
          sendGreetingAcceptedDesc: "Sends automatic greeting when a ticket is accepted",
          sendTransferMessage: "Send transfer message",
          sendTransferMessageDesc: "Sends a message when transferring between queues",
          removeTagsOnCloseTicket: "Remove tags on close",
          removeTagsOnCloseTicketDesc:
            "If enabled, closing a ticket removes all its tags and a confirmation is asked before closing",
          sendTicketCloseMessage: "Message when closing ticket",
          sendTicketCloseMessageDesc:
            "Sends a WhatsApp message when the ticket is closed (not for groups). Use {nroticket} for the ticket number",
          ticketCloseMessageText: "Close message text",
          ticketCloseMessageTextDesc:
            "Same rules as the automatic call message: required text (max 500 characters), editable with “Restore default”. Variable {nroticket} = ticket ID. Sent after confirmed close.",
          ticketCloseMessageTextPlaceholder:
            "💬⚙️ *Support ticket:* {nroticket} was closed. The bot will be active again in *5 minutes*",
          sendGreetingOneQueue: "Send greeting with one queue",
          sendGreetingOneQueueDesc: "Shows greeting when only one queue is available",
          globalSettings: "Global settings",
          registrationAllowed: "Registration allowed",
          registrationVisible: "Registration visible",
          trialTime: "Trial period",
          mainSettings: "Main settings",
          messagingSettings: "Messaging settings",
          customerMessageLocale: "Automatic message language for WhatsApp contacts",
          customerMessageLocaleDesc:
            "Language for greetings, transfers, templates, and automatic texts sent to the contact on WhatsApp. Independent from each operator's panel language.",
          scheduleTypeDesc: "Defines the type of business hours",
          ignoreGroupMessagesDesc: "Ignores WhatsApp group messages",
          chatbotTypeDesc: "Chatbot type for automatic replies",
          internalSignature: "Internal signatures",
          internalSignatureDesc:
            "Automatically shows the user name on each message (internal only)",
          validateWhatsAppNumbers: "Validate WhatsApp numbers",
          validateWhatsAppNumbersDesc:
            "On import, checks that the number exists on WhatsApp. Invalid numbers are not sent. If WhatsApp does not answer, the contact is saved and the campaign still tries.",
          timezoneForCampaigns: "Timezone for campaigns",
          timezoneForCampaignsDesc: "Select your timezone for mass campaigns",
          timezone: "Timezone",
          callAutoMessageMaxLength: "Message cannot exceed 500 characters",
          callAutoMessageSaveError: "Error saving message",
          characters: "characters",
          registrationAllowedDesc: "Allows registration of new users",
          registrationVisibleDesc: "Shows the registration form publicly",
          trialTimeDesc: "Trial days for new users",
          day: "day",
          days: "days",
          additionalSettings: "Additional settings",
          hubNotificaMeToken: "Hub NotificaMe — Account token",
          hubNotificaMeTokenDesc: "36-character token for Hub NotificaMe integration",
          hubNotificaMeTokenLabel: "Account token",
          hubNotificaMeTokenHelper: "Must be exactly 36 characters",
          webInfo: "Web info",
          websiteTitle: "Website title",
          websiteTitleDesc: "Title shown in the browser tab and search results",
          websiteDescription: "Website description",
          websiteDescriptionDesc: "Description shown in search and social previews",
          websiteKeyword: "Website keyword",
          websiteKeywordDesc: "Main SEO keywords",
          companyName: "Company name",
          companyNameDesc: "Company name on login copyright",
          companyNameCopyright: "Company name (copyright)",
          logos: "Logos",
          exampleCliqueaCRM: "Example: Cliquea CRM",
          exampleAutomatiza: "Example: Automate, connect and sell more!",
          exampleWhatsAppAPI: "Example: WHATSAPP API",
          exampleWatoolx: "Example: watoolx.com",
          localeEs: "Spanish",
          localeEn: "English",
          localePt: "Portuguese",
          loadingTimezones: "Loading timezones…",
          timezoneQuickPeru: "Peru (America/Lima)",
          timezoneQuickColombia: "Colombia (America/Bogota)",
          ariaSectionMain: "Main settings",
          ariaSectionMessaging: "Messaging settings",
        },
        states: {
          disabled: "Disabled",
          enabled: "Enabled",
          activated: "On",
          deactivated: "Off",
          accept: "Accept",
          notAccept: "Do not accept",
          text: "Text",
          updating: "Updating...",
          yes: "Yes",
          no: "No",
          queue: "Queue",
          company: "Company",
        },
        versionPage: {
          loading: "Loading version information…",
          title: "System version information",
          ariaVersion: "Version",
          currentVersion: "Current version",
          changelogChip: "changelog {{version}}",
          releaseDateChangelog: "Release date (CHANGELOG):",
          changeType: "Change type",
          gitDateChip: "Date via Git",
          releaseSummary: "Latest release summary",
          changesCount: "{{count}} changes",
          frontendVersion: "Frontend version",
          apiVersion: "API version (backend package)",
          baseWhaticket: "Base Whaticket:",
          lastUpdate: "Last update",
          semanticFooter: "Semantic versioning in use",
          fullHistory: "View full history →",
          na: "N/A",
        },
        subscriptionsPayment: {
          title: "Payment methods",
          intro: "Configure PayPal, Stripe and Binance Pay credentials to collect project subscriptions. ",
          introNote: "Note: After saving PayPal/Stripe, restart the backend server for changes to apply.",
          saving: "Saving…",
          sectionPaypal: "PayPal",
          sectionStripe: "Stripe",
          sectionBinance: "Binance Pay",
          sectionCurrency: "Currency",
          sectionManual: "Manual payment",
          binanceIntro:
            "Automatic USDT collection to your Binance Pay. Companies pay an exact amount; the system confirms and extends the due date.",
          binanceEnabled: "Binance Pay status",
          binanceOn: "Enabled",
          binanceOff: "Disabled",
          binanceApiKey: "API Key",
          binanceApiKeyDesc: "Binance → API Management: Enable Reading only. No withdrawals or trading.",
          binanceApiSecret: "API Secret",
          binanceApiSecretDesc: "Stored encrypted. Leave blank to keep the current secret.",
          binanceKeySet: "Already set — paste a new one only to replace it",
          binancePayId: "Pay ID / Binance ID",
          binanceQrUrl: "QR URL",
          binanceUploadQr: "Upload QR",
          binanceQrUploaded: "QR uploaded",
          binanceSave: "Save Binance Pay",
          binanceTest: "Test connection",
          binanceValidated: "Last validated: {date}",
          toastBinance: "Binance Pay saved",
          toastBinanceTest: "API Key valid (read-only)",
          paypalClientIdLabel: "PayPal client ID",
          paypalClientIdDesc: "Client ID of your PayPal application",
          paypalClientIdField: "PayPal Client ID",
          paypalClientIdHelper: "Example: AQkquBDf1zctJOWLbrloE4zQnlX4rQvBfhXUZHX96zShVqSB2ikbkGg",
          paypalSecretLabel: "PayPal client secret",
          paypalSecretDesc: "Secret of your PayPal application",
          paypalSecretField: "PayPal Client Secret",
          paypalSecretHelper: "Your PayPal application secret",
          paypalModeLabel: "PayPal mode",
          paypalModeDesc: "Sandbox (testing) or live (production)",
          modeField: "Mode",
          modeSandbox: "Sandbox (testing)",
          modeLive: "Live (production)",
          stripeKeyLabel: "Stripe secret key",
          stripeKeyDesc: "Secret key from your Stripe account (sk_test_… or sk_live_…)",
          stripeKeyField: "Stripe Secret Key",
          stripeKeyHelper: "Example: sk_test_51AbCdEf…",
          stripeWebhookLabel: "Stripe webhook secret",
          stripeWebhookDesc: "Webhook secret to verify events (whsec_…)",
          stripeWebhookField: "Stripe Webhook Secret",
          stripeWebhookHelper: "Example: whsec_1234567890abcdef",
          currencyLabel: "Preferred currency",
          currencyDesc: "Currency shown on plans and invoices",
          currencyField: "Currency",
          currencyUSD: "USD — US dollar ($)",
          currencyEUR: "EUR — Euro (€)",
          currencyGBP: "GBP — Pound sterling (£)",
          currencyBRL: "BRL — Brazilian real (R$)",
          currencyMXN: "MXN — Mexican peso ($)",
          currencyARS: "ARS — Argentine peso ($)",
          currencyCLP: "CLP — Chilean peso ($)",
          currencyCOP: "COP — Colombian peso ($)",
          currencyPEN: "PEN — Peruvian sol (S/)",
          toastPaypalId: "PayPal Client ID saved",
          toastPaypalSecret: "PayPal Client Secret saved",
          toastPaypalMode: "PayPal mode updated",
          toastStripeKey: "Stripe Secret Key saved",
          toastStripeWebhook: "Stripe Webhook Secret saved",
          toastCurrency: "Currency updated",
          manualIntro:
            "If no online gateway is configured, companies will see this information to coordinate a manual payment.",
          manualEmailLabel: "Billing email",
          manualWhatsappLabel: "Billing WhatsApp",
          manualInstructionsLabel: "Manual payment instructions",
          manualInstructionsPlaceholder:
            "Message us with the plan you want and we will send the payment details.",
          toastManualEmail: "Manual payment email saved",
          toastManualWhatsapp: "Manual payment WhatsApp saved",
          toastManualInstructions: "Manual payment instructions saved",
        },
        smtpManager: {
          pageTitle: "SMTP and templates",
          tabSmtp: "SMTP configurations",
          tabTemplates: "Email templates",
          sectionTitle: "SMTP configurations",
          newConfig: "New configuration",
          emptyList: "No SMTP configurations. Create one to get started.",
          colName: "Name",
          colProvider: "Provider",
          colHost: "Host",
          colPort: "Port",
          colUser: "User",
          colStatus: "Status",
          colActions: "Actions",
          defaultChip: "Default",
          statusActive: "Active",
          statusInactive: "Inactive",
          tooltipTest: "Test connection",
          tooltipEdit: "Edit",
          tooltipDelete: "Delete",
          dialogNew: "New SMTP configuration",
          dialogEdit: "Edit SMTP configuration",
          fieldName: "Name",
          fieldProvider: "Provider",
          providerCustom: "Custom",
          fieldDescription: "Description",
          fieldHost: "SMTP host",
          fieldPort: "Port",
          fieldUser: "User / email",
          fieldPassword: "Password",
          passwordKeepHint: "Leave blank to keep current",
          gmailTooltipTitle: "Gmail information",
          gmailTooltipBody: "For Gmail use an app password, not your normal password.",
          gmailTooltipSteps: "Steps:",
          gmailTooltipStep1: "1. Google → Security",
          gmailTooltipStep2: "2. Enable 2-step verification",
          gmailTooltipStep3: "3. Find “App passwords”",
          gmailTooltipStep4: "4. Generate password for “Mail”",
          gmailTooltipStep5: "5. Use the 16-character password here",
          gmailGuideLink: "Full guide",
          fieldFrom: "From",
          sslLabel: "SSL (port 465)",
          tlsLabel: "Require TLS (port 587)",
          activeLabel: "Active",
          defaultLabel: "Default",
          cancel: "Cancel",
          save: "Save",
          testDialogTitle: "Test SMTP connection",
          testSuccess: "Connection successful",
          testError: "Connection error",
          deleteConfirm: "Delete this configuration?",
          providerGmail: "Gmail",
          providerOutlook: "Outlook",
          fieldFromPlaceholder: "Name <email@domain.com>",
          testTitleSuccess: "Connection test successful",
          testTitleFail: "Connection test failed",
          testTitlePending: "Testing SMTP connection…",
          testVerifying: "Verifying connection to the SMTP server…",
          alertOkTitle: "Connection successful",
          alertOkBody: "The SMTP settings connected to the server successfully.",
          alertErrTitle: "Connection error",
          alertErrBody: "Could not connect to the SMTP server.",
          errorDetailsLabel: "Error details:",
          close: "Close",
          suggestedFixTitle: "Suggested fix:",
          suggestedFixBody:
            "If you use Gmail, use an app password instead of your normal password.",
        },
        vpsAlerts: {
          validation: {
            smtpSelect:
              "SMTP: pick an account in “SMTP configuration *” (do not leave “Select SMTP…”).",
            adminEmailRequired: "Admin email: required when using email.",
            adminEmailInvalid: "Admin email: invalid format.",
            whatsappSelect:
              "WhatsApp: pick a line in “WhatsApp connection *” (empty blocks save and nothing is sent).",
            adminWhatsappRequired: "Admin WhatsApp number: required when using WhatsApp.",
            adminWhatsappInvalid: "WhatsApp number: use 10–15 digits; you may prefix +.",
            whatsappTemplateRequired: "WhatsApp message template cannot be empty.",
          },
          validationModal: {
            bodyIntro: "The request was not sent. Complete the following:",
            titleTest: "Missing data for the test",
            titleSave: "Cannot save: incomplete form",
          },
          notes: {
            noActiveSmtpTest: "Note: no active SMTP accounts. Configure one in the “SMTP” tab.",
            noActiveSmtpSave:
              "Note: no active SMTP accounts. Create or activate one in the “SMTP” tab.",
            noConnectedWhatsapp: "Note: no WhatsApp in CONNECTED status; check “Connections”.",
          },
          test: {
            lineEmailOk: "✅ Email sent successfully",
            lineWhatsappOk: "✅ WhatsApp sent successfully",
            successIntro: "Test notification sent successfully:",
            footerEmail: "Check your email to confirm receipt.",
            footerWhatsapp: "Check your WhatsApp to confirm receipt.",
            footerBoth: "Check your email and WhatsApp to confirm receipt.",
            errorIntro: "Error sending test notification:",
            unknownError: "Unknown error",
          },
          save: {
            notSavedTitle: "Configuration was not saved",
            notSavedBody:
              "Check any error message on screen and your connection. If it persists, try again in a few seconds.",
            successTitle: "✅ Configuration saved",
            successBody: "VPS notification settings were saved successfully.",
            errorTitle: "❌ Save error",
            errorBody: "Error saving configuration: {{message}}",
          },
          loadError:
            "Could not load VPS alert configuration: {{error}}. Ensure your user is admin, the API is available, and DB objects exist (VPSNotificationConfig, SP).",
          retry: "Retry",
          generalSection: "General enablement",
          toggleLabel: "Enable alert system and automatic cleanup",
          infoWhyTitle: "Why enable this system?",
          infoIntro: "This alert and automatic cleanup system is especially useful if:",
          infoLi1: "Your business handles thousands of WhatsApp messages daily",
          infoLi2: "You generate many database records",
          infoLi3: "You need proactive server monitoring",
          infoLi4: "You want to prevent full-disk issues",
          infoClosing:
            "If your business is small and generates few records, you can leave this system disabled.",
          warningEnabled:
            "IMPORTANT: Once enabled, you will receive automatic alerts when the system detects issues. Configure email or WhatsApp credentials correctly.",
          notificationsSection: "Notification settings",
          channelEmail: "Email",
          channelWhatsapp: "WhatsApp",
          channelBoth: "Both",
          emailSection: "Email settings",
          smtpRequiredLabel: "SMTP configuration *",
          selectSmtp: "Select SMTP…",
          emailTemplateOptional: "Email template (optional)",
          useDefaultTemplates: "Use default templates",
          adminEmailLabel: "Admin email *",
          invalidEmail: "Invalid email format",
          adminEmailHint: "Email where you will receive alerts",
          whatsappSection: "WhatsApp settings",
          whatsappConnectionLabel: "WhatsApp connection *",
          selectWhatsapp: "Select WhatsApp…",
          whatsappTemplateLabel: "WhatsApp message template",
          whatsappTemplateVars:
            "Available variables: {alertType}, {diskUsage}, {binaryLogsSize}, {cpuUsage}, {memoryUsage}, {message}, {subject}",
          adminWhatsappLabel: "Admin WhatsApp number *",
          invalidWhatsapp: "Invalid format (10–15 digits, optional +)",
          adminWhatsappHint: "Number where you will receive alerts (with country code)",
          thresholdsSection: "Alert thresholds",
          diskPct: "Disk (%)",
          diskHelp: "Alert when disk use exceeds this percentage",
          binaryGb: "Binary logs (GB)",
          binaryHelp: "Alert when binary log size exceeds this value",
          cpuPct: "CPU (%)",
          cpuHelp: "Alert when CPU use exceeds this percentage",
          memPct: "Memory (%)",
          memHelp: "Alert when memory use exceeds this percentage",
          enableDisk: "Enable disk alerts",
          enableBinary: "Enable binary log alerts",
          enableCpu: "Enable CPU alerts",
          enableMem: "Enable memory alerts",
          enableCritical: "Enable critical alerts",
          frequencySection: "Notification frequency and automatic cleanup",
          alertFreqLabel: "Alert frequency (hours)",
          alertFreqHelp: "How often automatic alerts are sent (1–48 hours)",
          cleanupSubtitle: "Automatic server cleanup",
          cleanupInfoTitle: "What this section does",
          cleanupInfoIntro:
            "With cleanup enabled, the system can run maintenance without manual steps:",
          cleanupInfoLi1:
            "If disk exceeds the threshold (%): full routine (binary log purge per server policy, iterative steps, critical table optimization when needed).",
          cleanupInfoLi2:
            "If disk is below threshold but MySQL binary logs exceed the GB threshold: progressive log purge (conservative then more aggressive), typical when total disk is large but binlogs grow fast.",
          cleanupRisk:
            "Operational risk: binary log purge affects point-in-time recovery (PITR). Use thresholds aligned with your backup and MySQL replication policy.",
          enableAutoCleanup: "Enable automatic cleanup",
          cleanupCooldownNote:
            "Alert frequency ({{hours}} h) also limits how often cleanup triggered only by binary logs (GB) can repeat (cooldown since last run of that type).",
          cleanupDiskThreshold: "Disk threshold for cleanup (%)",
          cleanupDiskHelp:
            "When disk use reaches this %, the full cleanup routine runs (binlogs + extra DB steps as applicable).",
          cleanupBinlogGb: "Binary log threshold for cleanup (GB)",
          cleanupBinlogHelp:
            "If estimated binary log size ≥ this value and disk did not trigger the previous routine, logs are purged progressively. Often lower than alert-only threshold (GB).",
          lastCleanup: "Last automatic cleanup (binary log threshold): {{date}}",
          saveConfig: "Save configuration",
          saving: "Saving…",
          sendTest: "Send test notification",
          sending: "Sending…",
          testModal: {
            sending: "Sending test notification…",
            success: "✅ Notification sent",
            error: "❌ Send error",
            pleaseWait: "Please wait while the notification is sent…",
            tipPrefix: "Tip:",
            tipEmail: "Check your email to confirm receipt.",
            tipWhatsapp: "Check your WhatsApp to confirm receipt.",
            tipBoth: "Check your email and WhatsApp to confirm receipt.",
            close: "Close",
            cancel: "Cancel",
          },
          accept: "OK",
          defaultWhatsAppTemplate:
            "⚠️ VPS ALERT: {alertType}\n📊 System status:\n💾 Disk: {diskUsage}%\n📝 Binary logs: {binaryLogsSize} GB\n⚡ CPU: {cpuUsage}%\n🧠 Memory: {memoryUsage}%\n\n{message}",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        mediaCaptionPlaceholder: "Add a caption… (optional — sent with the file)",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        openInNewWindow: "Open chat in popup",
        openInNewUnavailable: "This ticket has no UUID and cannot be opened in a new tab.",
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_COMPANY_INVALID_DUE_DATE: "The company expiration date is invalid.",
        ERR_NO_OTHER_WHATSAPP: "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND: "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT: "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA: "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_COMPANY_EXPIRED:
          "The trial or plan has ended. Choose a plan and complete payment to use the system again.",
        COMPANY_EXPIRED_BANNER:
          "Your trial or plan has ended. Choose a plan and complete payment to restore access. WhatsApp connections and their history are removed when it ends.",
        COMPANY_EXPIRED_MENU:
          "The rest of the system stays restricted until the plan is active.",
        ERR_SENDING_WAPP_MSG: "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED: "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG: "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "This color is already in use, pick another one.",
        ERR_QUEUE_NAME_ALREADY_EXISTS: "This department name already exists, choose another one.",
        ERR_WAPP_GREETING_REQUIRED: "Greeting message is required if there is more than one queue.",
        ERR_INTERNAL_SERVER: "Internal server error. Try again or contact support.",
        ERR_DB_VALIDATION: "The data did not pass database validation rules.",
        ERR_TICKET_UPDATE_FAILED: "Could not update the ticket. Please try again.",
        ERR_SETTING_FOREIGN_COMPANY: "You cannot change another company's settings.",
        ERR_NO_WBOT_FOR_WHATSAPP:
          "No active WhatsApp session for connection {{whatsappId}}. Check the connections page.",
        ERR_UNKNOWN: "An unexpected error occurred.",
      },
    },
  },
};

extendGettingStartedTranslations(messages.en.translations, "en");

export { messages };
